import React, { FC, Fragment, useCallback, useEffect, useMemo, useRef, useState } from "react";
import CommentListing from "components/CommentListing/CommentListing";
import FiveStartIconForRate from "components/FiveStartIconForRate/FiveStartIconForRate";
import StartRating from "components/StartRating/StartRating";
import Avatar from "shared/Avatar/Avatar";
import Badge from "shared/Badge/Badge";
import LikeSaveBtns from "components/LikeSaveBtns";
import SectionDateRange from "../SectionDateRange";
import StayDatesRangeInput from "./StayDatesRangeInput";
import { useLocation, useNavigate } from "react-router-dom";
import { Amenities_demos, PHOTOS } from "./constant";
import { Dialog, Transition } from "@headlessui/react";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import ButtonClose from "shared/ButtonClose/ButtonClose";
import ButtonCircle from "shared/Button/ButtonCircle";
import Input from "shared/Input/Input";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import DetailPagetLayout from "../Layout";
import GuestsInput from "./GuestsInput";
import axios from "axios";
import { base_url } from "constant/constant";
import moment from 'moment';
import { toFilterDateString } from "utils/filterDates";
import GoogleMapReact from "google-map-react";
import Button from "shared/Button/Button";
import { loadStripe } from "@stripe/stripe-js";
import NcInputNumber from "components/NcInputNumber/NcInputNumber";
import ContactFormModal from "./CustomerDilouge";
import PhotoGalleryModal from "components/PhotoGalleryModal/PhotoGalleryModal";
import PriceBreakdownPopup from "./CustomRateDisplay";
import { useLocale } from "i18n/locale";
import CustomFees from "./CustomeFeesDilouge";
import CustomerDetails from "./CustomerDetails";
import useOutsideAlerter from "hooks/useOutsideAlerter";
import { useAppContext } from "AppContext";
import { useWishlist } from "WishlistContext";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import BookedNightsCounter, { BookedNightsData } from "./BookedNightsCounter";
import pinIcon from "images/card/pin-icon.svg";
import minusCircleIcon from "images/header/minus-circle.svg";
import plusCircleIcon from "images/header/plus-circle.svg";
import shareIcon from "images/card/share-icon.svg";
import wishlistIcon from "images/card/wishlist-icon.svg";
import airbnbLogo from "images/card/airbnb-logo.png";
import bookingLogo from "images/card/booking-logo.png";
import vrboLogo from "images/card/vrbo-logo.png";
import penToSquareIcon from "images/card/pen-to-square.svg";
import smokeDetectorIcon from "images/card/smoke-detector.svg";
import firstAidKitIcon from "images/card/first-aid-kit.svg";
import carbonMonoxideIcon from "images/card/carbon-monoxide.svg";
import fireExtinguisherIcon from "images/card/fire-extinguisher.svg";
import pawprintIcon from "images/card/pawprint.svg";
import noSmokingIcon from "images/card/no-smoking.svg";
import noPartiesIcon from "images/card/no-parties.svg";
import quietHoursIcon from "images/card/quiet-hours.svg";
import mapMarkerIcon from "images/card/map-marker.svg";
import reviewAirbnbLogo from "images/card/review-airbnb-logo.png";
import reviewBookingLogo from "images/card/review-booking-logo.png";
// Expedia has no PNG in images/card, so it comes from the SVG set the tenant
// platform already ships. Airbnb and Booking stay on their PNGs so the two
// marks already on the page keep the exact look they have now.
import reviewExpediaLogo from "containers/TenantPlatform/channel-logos/expedia.svg";
import reviewVrboLogo from "containers/TenantPlatform/channel-logos/vrbo.svg";
import trustManagedIcon from "images/card/trust-managed.svg";
import trustGuestsIcon from "images/card/trust-guests.svg";
import trustSecureIcon from "images/card/trust-secure.svg";
import bedIcon from "images/card/bed-icon.svg";
import bathIcon from "images/card/bath-icon.svg";
import kitchenIcon from "images/card/kitchen-icon.svg";
import sleepsIcon from "images/card/sleeps-icon.svg";
import getImageVariantUrl from "utils/getImageVariantUrl";
import { formatAmount } from "utils/formatAmount";
import checkCircleGold from "images/header/check-circle-gold.svg";


export interface propertyDetails {
  type?: string,
  house_rules?: string,
  title?: string,
  cancellation_policy?: string,
  cancellation_policy_fr?: string,
  description?: descriptionModel,
  location?: string,
  bedrooms?: any,
  bathrooms?: any,
  toilets?: any,
  amenities?: any,
  policies?: any,
  security_and_safety?: any,
  accessibility?: any,
  [key: string]: any,
  coordinates?: cordinatesDetails
  check_in_time?: any,
  check_out_time?: any,
  residence_licence_number?: any
}

export interface descriptionModel {
  en?: string;
  fr?: string
}
export interface cordinatesDetails {
  coordinates: any
}
export interface StayDatesRangeInputProps {
  className?: string;
}

interface RateData {
  totalRate: number;
  nights: number;
  cleaningFees: number;
  communityFees: number;
  managementFees: number;
  cityTax: number;
  calRateWithoutfees: number;
  weeklyDisc: number,
  monthlyDisc: number,
  priceListByDates: any,
  rentWithDescount: number
}

interface ApiResponse {
  error: boolean;
  title: string;
  data: RateData;
}

interface PropertySectionAmenity {
  name: string;
  value?: string[];
}
interface PropertySection {
  _id: string;
  title: string;
  images: string[];
  cover_images?: string[];
  amenities: PropertySectionAmenity[];
}

type FormValues = {
  name: string;
  email: string;
  phone: string;
  isChecked: boolean;
};


interface PropertyReview {
  _id: string;
  guest_name?: string | null;
  source?: string | null;
  review_date?: string | null;
  stay_dates_raw?: string | null;
  rating_five?: number | null;
  rating_original?: number | null;
  rating_scale?: number | null;
  review_title?: string | null;
  review_text?: string | null;
  text_truncated?: boolean | null;
  // Set by the API when Airbnb cut the comment short: the listing's public
  // reviews page on airbnb.fr, where the full comment can be read.
  read_more_url?: string | null;
}

const StayDetailPageContainer: FC<{}> = () => {
  const { setTotalAmount, updateFilterState, paymentSectionRef, setBasePrice } = useAppContext();
  const { isSaved, toggleWishlist } = useWishlist();
  const { locale, t } = useLocale();

  let [images, setImages] = useState([])
  const [blockedDates, setBlockedDates] = useState<Date[]>([]);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [numberOfPerson, setNumberOfPerson] = useState(1);
  const [guestChildrenInputValue, setGuestChildrenInputValue] = useState(0);
  const [guestInfantsInputValue, setGuestInfantsInputValue] = useState(1);
  const [openContactModal, setOpenContactModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [bookedNightsData, setBookedNightsData] = useState<BookedNightsData | null>(null);

  // Guest reviews collected from the channels and published from the DMS.
  // `reviewsSummary` is the overall score shown above the list; it is computed
  // from published reviews only, so it always matches what a visitor can read.
  const [reviews, setReviews] = useState<PropertyReview[]>([]);
  const [reviewsSummary, setReviewsSummary] = useState<{ average: number | null; count: number }>({ average: null, count: 0 });
  const [showAllReviews, setShowAllReviews] = useState(false);
  // Which review cards have been expanded, keyed by the card's id. Per card
  // rather than one flag, so opening one long review leaves the others short.
  const [expandedReviews, setExpandedReviews] = useState<Record<string, boolean>>({});
  const [carouselIndex, setCarouselIndex] = useState(0);
  const carouselTrackRef = useRef<HTMLDivElement>(null);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [dateSelecting, setDateSelecting] = useState<"start" | "end">("start");
  const [calBaseMonth, setCalBaseMonth] = useState(() => {
    const d = new Date();
    return { year: d.getFullYear(), month: d.getMonth() };
  });
  const datePickerRef = useRef<HTMLDivElement>(null);
  const [showGuestPicker, setShowGuestPicker] = useState(false);
  const guestPickerRef = useRef<HTMLDivElement>(null);
  const [showPriceDetails, setShowPriceDetails] = useState(false);
  const [showFeesPopup, setShowFeesPopup] = useState(false);
  const feesPopupRef = useRef<HTMLDivElement>(null);
  useOutsideAlerter(feesPopupRef, () => setShowFeesPopup(false));
  const [showFullDescription, setShowFullDescription] = useState(false);
  const [galleryOpen, setGalleryOpen] = useState(false);
  const [galleryInitialIndex, setGalleryInitialIndex] = useState(0);
  const [propertySections, setPropertySections] = useState<PropertySection[]>([]);

  let [propertyDetails, setPropertyDetails] = useState<propertyDetails>();
  const [rateData, setRateData] = useState<RateData | null>(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [formValues, setFormValues] = useState<FormValues>({
    name: "",
    email: "",
    phone: "",
    isChecked: false,
  });
  // Personal details count as "filled" on the same terms the booking API needs:
  // a name, an email, and accepted terms.
  const isPersonalDetailsFilled = Boolean(
    formValues.name?.trim() && formValues.email?.trim() && formValues.isChecked
  );
  const [isPopupOpen, setPopupOpen] = useState(false);
  const thisPathname = useLocation().pathname;
  const router = useNavigate();

  const url = new URL(window.location.href);
  const id = url.searchParams.get("id");
  const buttonRef = useRef<HTMLButtonElement | null>(null);
  // Google Maps instance for the location map, so the custom +/- buttons can
  // drive zoom. Zoom is capped (see minZoom/maxZoom) so the exact address can't
  // be revealed by zooming all the way in.
  const locationMapRef = useRef<any>(null);
  const LOCATION_MAP_MIN_ZOOM = 11;
  const LOCATION_MAP_MAX_ZOOM = 15;

  // Add near your other constants (outside the component, or right above renderSection2/return)
  const PLATFORM_META: Record<string, { logo: string; label: string }> = {
    Airbnb: { logo: airbnbLogo, label: "AirBnB" },
    Booking: { logo: bookingLogo, label: "Booking.com" },
    VRBO: { logo: vrboLogo, label: "Vrbo" },
  };

  // Generic fallback for any siteType without a local icon (Expedia, Google, etc.)
  const getFallbackFavicon = (url: string) => {
    try {
      const domain = new URL(url).hostname;
      return `https://www.google.com/s2/favicons?domain=${domain}&sz=64`;
    } catch {
      return "";
    }
  };

  const fetchPropertyInfo = async () => {
    const url = new URL(window.location.href);
    const id = url.searchParams.get("id");
    const response = await axios.get(`${base_url}/property/website_property_details?property_id=${id}`)

    if (response.data.error === false) {
      let data = response.data.data
      setImages(data?.images)
      setPropertyDetails(data)
      setBasePrice(data?.base_price)
    }
    else {

    }
  }

  const fetchPropertySections = async () => {
    try {
      const url = new URL(window.location.href);
      const id = url.searchParams.get("id");
      const response = await axios.get(`${base_url}/propertyImage/property_image_for_website?property_id=${id}`);
      if (!response.data.error) {
        // Skip legacy/aggregate docs (old add_images1 used title === 'all') and
        // anything with no images — nothing useful to show as a card.
        const sections = (response.data.data || []).filter(
          (s: PropertySection) => s?.title && s.title.toLowerCase() !== 'all' && s.images?.length > 0
        );
        setPropertySections(sections);
      }
    } catch (error) {
      console.error("Error fetching property sections:", error);
    }
  };

  const fetchBookedNightsCounter = async () => {
    try {
      const url = new URL(window.location.href);
      const id = url.searchParams.get("id");
      const response = await axios.get(`${base_url}/property/website_booked_nights_counter?property_id=${id}`);
      if (!response.data.error && response.data.data) {
        setBookedNightsData(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching booked nights counter:", error);
    }
  };

  const fetchPropertyReviews = async (loadAll = false) => {
    try {
      const url = new URL(window.location.href);
      const id = url.searchParams.get("id");
      const response = await axios.get(`${base_url}/review/website_property_reviews`, {
        params: { property_id: id, page: 1, limit: loadAll ? 100 : 4 },
      });
      if (!response.data.error) {
        setReviews(response.data.data || []);
        setReviewsSummary(response.data.summary || { average: null, count: 0 });
      }
    } catch (error) {
      // Reviews are additional to the listing — if they fail to load, the rest
      // of the page must still render.
      console.error("Error fetching property reviews:", error);
    }
  };

  const scrollToReviews = () => {
    document.getElementById("reviews")?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  // Channel logos we hold artwork for. An unknown source simply shows no
  // badge rather than a broken image.
  const reviewPlatformLogo = (source?: string | null) => {
    switch ((source || "").toLowerCase()) {
      case "airbnb":
        return reviewAirbnbLogo;
      case "booking":
        return reviewBookingLogo;
      case "expedia":
        return reviewExpediaLogo;
      case "vrbo":
        return reviewVrboLogo;
      default:
        return null;
    }
  };

  // Reviews arrive from the channels without a usable profile picture, so the
  // guest's initial stands in for one.
  const reviewInitial = (name?: string | null) =>
    (name || "").trim().charAt(0).toUpperCase();

  // Booking.com sends a short summary line plus a longer comment; Airbnb sends
  // only a comment. The summary is shown first when both are present.
  const reviewDisplayText = (review: PropertyReview) =>
    [review.review_title, review.review_text].filter(Boolean).join(" — ") || "";

  /**
   * How much of a review is shown before "show more" appears — about three
   * lines in the two-column grid. A card whose text is within a little of the
   * limit is left whole, so the toggle is never offered to reveal a few words.
   */
  const REVIEW_CLAMP = 200;

  /** Cut back to a word boundary so the preview never ends mid-word. */
  const truncateReview = (value: string) => {
    const cut = value.slice(0, REVIEW_CLAMP);
    const lastSpace = cut.lastIndexOf(" ");
    return (lastSpace > REVIEW_CLAMP * 0.6 ? cut.slice(0, lastSpace) : cut).trimEnd();
  };

  /**
   * Row of five stars filled to `rating`, including partial fill for a score
   * such as 4.7. `idPrefix` keeps the clip-path ids unique — several rows are
   * rendered on the page and duplicate ids would clip the wrong star.
   *
   * `color` defaults to the brand navy. The rating summary under the title and
   * the reviews-section heading pass the brand gold instead.
   *
   * Every row uses the rounded star from images/card/review-stars-*.svg, drawn
   * in an 11x10 box — so `size`/`height` should keep roughly that 11:10 ratio.
   */
  const STAR_PATH =
    "M0.289533 4.51235L2.43393 5.9917C2.67895 6.16064 2.7816 6.46014 2.6882 6.73362L1.86863 9.12788C1.65954 9.73949 2.39666 10.2482 2.94491 9.87027L5.0893 8.3907C5.33432 8.22152 5.6658 8.22152 5.91082 8.3907L8.05521 9.87027C8.60322 10.2482 9.34058 9.73949 9.13149 9.12788L8.31229 6.73362C8.2184 6.46014 8.32105 6.16064 8.56632 5.9917L10.7105 4.51235C11.2582 4.13422 10.977 3.31123 10.2997 3.31123H7.64908C7.34634 3.31123 7.07733 3.12598 6.98405 2.8525L6.16509 0.45905C5.95576 -0.153017 5.04461 -0.153017 4.83503 0.45905L4.01558 2.85262C3.9223 3.1261 3.65427 3.31135 3.35104 3.31135H0.700291C0.0229605 3.31135 -0.258226 4.13434 0.289533 4.51235Z";
  const renderStars = (
    rating: number,
    idPrefix: string,
    size = 24,
    height = 22,
    color = "#13263F",
    gap = 2
  ) => (
    <div style={{ display: "flex", alignItems: "center", gap }}>
      {[1, 2, 3, 4, 5].map((star) => {
        const fill = star <= Math.floor(rating) ? 1 : star === Math.ceil(rating) ? rating % 1 : 0;
        const clipId = `starClip-${idPrefix}-${star}`;
        return (
          <svg key={star} width={size} height={height} viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <clipPath id={clipId}>
                <rect x="0" y="0" width={11 * fill} height="10" />
              </clipPath>
            </defs>
            <path d={STAR_PATH} fill="#d6d6d6" />
            <path d={STAR_PATH} fill={color} clipPath={`url(#${clipId})`} />
          </svg>
        );
      })}
    </div>
  );

  const CalculateRate = async (startDate: any, endDate: any, number_of_guests: any) => {
    try {
      setLoading1(true)
      const url = new URL(window.location.href);
      const id = url.searchParams.get("id");
      const totalGuests = guestChildrenInputValue + number_of_guests;
      const response = await axios.post<ApiResponse>(`${base_url}/property/calculate_rate`, {
        propertyId: id,
        checkInDate: moment(startDate).format("YYYY-MM-DD"),
        checkOutDate: moment(endDate).format("YYYY-MM-DD"),
        number_of_guest: Number(totalGuests),
      });
      setLoading1(false)
      if (!response.data.error) {
        const rateData = response.data.data
        const perDayRate = rateData.calRateWithoutfees / rateData.nights
        setTotalAmount(perDayRate)
        setRateData(response.data.data);
        setErrorMessage(null);
        setLoading(true)

      } else {
        setErrorMessage(response.data.title);
      }
    } catch (error) {
      setLoading1(false)
      console.error("Error fetching rate data:", error);
      setErrorMessage("Something went wrong while calculating the rate.");
    }
  };

  const addCustomerInfo = () => {
    if (formValues.name && formValues.email && formValues.isChecked) {
      bookProperty()
    } else {
      setOpenContactModal(true)
    }
  }

  // Returns true once the booking exists and the Stripe hand-off has been
  // started, so the caller knows whether it is safe to close the form.
  const bookProperty = async (): Promise<boolean> => {
    try {
      // No rate means calculate_rate rejected these dates (minimum stay,
      // unavailable nights, …). Booking anyway persists "NaN" amounts and the
      // Stripe session is then refused, so stop here instead.
      if (!rateData) {
        setErrorMessage(
          (prev) => prev || "Please choose dates with a valid price before booking."
        );
        return false;
      }
      const totalRate = rateData?.totalRate;
      const cleaningFees = Number(rateData?.cleaningFees).toFixed(2)
      const community_fees = rateData?.communityFees;
      const management_fees = rateData?.managementFees;
      const cityTax = Number(rateData?.cityTax).toFixed(2);
      const rent_excluding_fees = Number(rateData?.rentWithDescount).toFixed(2)
      const grossAmount = (Number(totalRate) - Number(cityTax)).toFixed(2)
      const bookingRes = await axios.post(`${base_url}/booking/booking_created_from_website`, {
        property_id: id,
        type: "Booked by europea",
        status: "pending",
        start_date: moment(startDate).format("YYYY-MM-DD"),
        end_date: moment(endDate).format("YYYY-MM-DD"),
        cleaning_fees: cleaningFees, community_fees, rent: rent_excluding_fees, city_tax: cityTax,
        gross_amount: grossAmount, management_fees, number_of_person: Number(numberOfPerson + guestChildrenInputValue),
        number_of_adults: numberOfPerson,
        number_of_children: guestChildrenInputValue,
        number_of_infants: guestInfantsInputValue,
        guest_name: formValues.name,
        guest_email: formValues.email,
        guest_phone: formValues.phone
      });
      if (!bookingRes.data.error) {
        setErrorMessage(null);
        const id = bookingRes.data.data._id
        const amt = bookingRes.data.data.rent
        return await handlePayment(amt, id)
      }
      setErrorMessage(bookingRes.data.title || "Somethig went wrong");
      return false;
    } catch (err) {
      setErrorMessage("Something went wrong while creating the booking.");
      return false;
    }
  }


  const handlePayment = async (amt: number, id: any): Promise<boolean> => {
    // const stripePublicKey = "pk_test_51QRSaBDgf9hHTePcbPg5OZ0Updg5nJbJ5e9tdtj9vphrVeCxXQ8bVmT9nM0Y74XuMTlqPWVy3to8TnNVALZdG3N700QdyeERC0"; //developer
    // const stripePublicKey = "pk_test_51QNtMrDypEZS83khQOJlDeUgijVZNDvSyKalrmiFVNlLf8w5QXq0zkwZ5ESDUghDZ7QTzAtUUUt547BnBiIxpWEJ0047Sabpco" // test live
    const stripePublicKey = "pk_live_51QNtMrDypEZS83khOQXPeoNLaZXE955nCTrSpYC6xeqnOJH3bNV1WCiNaoGCC0P7xMMnaFrYmpBTZQ7azL4CF5mH00YTg4tPTA" //  live

    try {
      const amount = Number(amt)
      if (!Number.isFinite(amount) || amount <= 0) {
        setErrorMessage("Amount should be greater than zero.");
        return false;
      }
      if (id) {
        const stripe = await loadStripe(stripePublicKey);
        if (!stripe) {
          throw new Error("Stripe failed to load.");
        }

        const { data } = await axios.post(`${base_url}/stripe/create-checkout-session`, {
          amount,
          currency: "eur",
          bookingId: id
        });

        if (!data.sessionId) {
          throw new Error("Failed to create a checkout session.");
        }

        const result = await stripe.redirectToCheckout({ sessionId: data.sessionId });

        if (result.error) {
          throw new Error(`Stripe Checkout redirection failed: ${result.error.message}`);
        }

        return true;
      }

      setErrorMessage("Error: Booking id is missing");
      return false;
    } catch (error) {
      // Silence here is what made a failed payment look like a dead button.
      console.error("Payment error:", error);
      setErrorMessage((error as Error).message || "Payment could not be started.");
      return false;
    }
  };

  useEffect(() => {
    fetchPropertyInfo()
    fetchBookedNightsCounter()
    fetchPropertySections()
    fetchPropertyReviews()
  }, [])

  useEffect(() => {
    const start_date = url.searchParams.get("start_date");
    const end_date = url.searchParams.get("end_date");
    const numberOfPerson = url.searchParams.get("number_of_guests");
    const numberOfChild = url.searchParams.get("number_of_children");
    const numberOfInfants = url.searchParams.get("number_of_infants");
    if (start_date && start_date != "null") {
      setStartDate(start_date ? new Date(start_date) : null)
    }
    if (end_date && end_date != "null") {
      setEndDate(new Date(end_date))
    }
    if (numberOfPerson) {
      setNumberOfPerson(Number(numberOfPerson))
    }
    if (numberOfChild) {
      setGuestChildrenInputValue(Number(numberOfChild))
    }
    if (numberOfInfants) {
      setGuestInfantsInputValue(Number(numberOfInfants))
    }
    if (end_date && start_date && start_date != "null" && end_date != "null") {
      CalculateRate(start_date, end_date, numberOfPerson)
    }

  }, [])

  // filterState holds "YYYY-MM-DD" strings, not Date objects — the header's
  // date filter parses them by string concatenation and renders "Invalid Date"
  // if it is handed anything else.
  useEffect(() => {
    updateFilterState("checkOutDate", toFilterDateString(endDate))
  }, [endDate])

  useEffect(() => {
    updateFilterState("checkInDate", toFilterDateString(startDate))
  }, [startDate])

  const generateDatesInRange = async (start: Date, end: Date) => {
    console.log("Start Date:", start);
    console.log("End Date:", end);

    // Ensure both start and end are valid Date objects
    if (!(start instanceof Date) || isNaN(start.getTime())) {
      console.error("Invalid start date");
      return [];
    }

    if (!(end instanceof Date) || isNaN(end.getTime())) {
      console.error("Invalid end date");
      return [];
    }

    const dates: Date[] = [];
    let currentDate = new Date(start);

    while (currentDate <= end) {
      await dates.push(new Date(currentDate));
      await currentDate.setDate(currentDate.getDate() + 1);
    }

    console.log("Generated Dates:", dates);
    return dates;
  };

  const getBooking = async () => {
    const token = localStorage.getItem('europea_token');
    const response = await axios.get(`${base_url}/booking/booking_listing_for_website?property_id=${id}`);

    // Map through the events and await each generateDatesInRange call using Promise.all
    const events = await Promise.all(
      response?.data?.data?.map(async (event: any) => {
        return await generateDatesInRange(new Date(event.start_date), new Date(event.end_date));
      })
    );

    console.log("Blocked Dates:", events);

    // Flatten the array if generateDatesInRange returns an array for each event
    const allBlockedDates = events.flat();
    setBlockedDates(allBlockedDates);
  };

  useEffect(() => {
    getBooking();
  }, []);

  // useEffect(() => {
  //   const dates = bookedDateRanges.flatMap((range) =>
  //     generateDatesInRange(range.start, range.end)
  //   );
  //   setBlockedDates(dates);
  // }, []);


  const excludeStreetNumber = (address: String) => {
    return address?.replace(/^\d+\s*/, ""); // Removes leading numbers and whitespace
  };

  const renderSection2 = () => {
    return (
      <div className="listingSection__wrap shadow-md bg-white">
        <div className="flex justify-between items-center pl-4 md:pl-0 flex-wrap gap-4">
          <h2 className="text-2xl darkTitleForHeader inline-block">Residence Information</h2>
          <div className="flex items-center gap-3">
            {bookedNightsData && (
              <BookedNightsCounter data={bookedNightsData} year={new Date().getFullYear()} />
            )}
          </div>
          {propertyDetails?.type_of_unit && (
            <div className="px-3 py-1 text-sm text-[#0c586e] border border-[#0c586e] rounded-full">
              {propertyDetails.type_of_unit}
            </div>
          )}
        </div>
        <hr className="-mx-1 sm:-mx-6" />
        <div className="text-neutral-6000 dark:text-neutral-300 pl-4 md:pl-0">
          <div className="flex justify-between items-center" style={{ gap: '16px' }}>
            <div className="flex items-center justify-between gap-4 flex-wrap w-full">
              <span
                className="px-3 py-2 text-white bg-[#DBAE74] rounded-full flex-shrink-0"
                style={{
                  maxWidth: "300px",
                  minWidth: "75px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {propertyDetails?.status_of_unit}
              </span>

              <div className="flex justify-center items-center flex-1 min-w-[150px] max-w-[calc(100%-200px)] mx-2">
                <i className="las la-map-marker-alt la-lg text-xl flex-shrink-0"></i>
                <div className="ml-1 text-sm break-words">
                  {excludeStreetNumber(propertyDetails?.address)}
                </div>
              </div>

              {propertyDetails?.residence_licence_number && (
                <span className="text-[#0c586e] text-sm font-semibold flex-shrink-0 ml-2">
                  {propertyDetails?.residence_licence_number}
                </span>
              )}
            </div>
          </div>
          <br />
          <h2 className="text-2xl mt-5 text-black">
            {propertyDetails?.title}
          </h2>
          <p>
            {propertyDetails?.bedrooms ?? 1} {propertyDetails?.bedrooms > 1 ? ' Bedrooms' : ' Bedroom'} .   {propertyDetails?.bathrooms ?? 1} {propertyDetails?.bathrooms > 1 ? ' Bathrooms' : ' Bathroom'} .   {propertyDetails?.toilets ?? 1}  {propertyDetails?.toilets > 1 ? ' Toilets' : ' Toilet'}
          </p>
          <br />
          <div className="text-gray-700 text-sm leading-relaxed text-justify" style={{ whiteSpace: "pre-line" }}>
            {propertyDetails?.description?.[locale] || propertyDetails?.description?.en}
          </div>
          <br />
        </div>
      </div>
    );
  };

  const renderSection3 = () => {
    const amenitiesData = propertyDetails?.amenities || [];

    return (
      <div className="listingSection__wrap shadow-md bg-white">
        <h2 className="text-2xl darkTitleForHeader inline-block pl-4 md:pl-4">Amenities</h2>
        <hr className="-mx-1 sm:-mx-6" />
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-6 text-sm text-neutral-700 dark:text-neutral-300 p-4 pl-4 md:pl-2">
          {Amenities_demos.map((item) => {
            const isPresent = amenitiesData.some(
              (amenity: any) =>
                amenity.name.toLowerCase().includes(item.name.toLowerCase())
            );
            const amenityValue = amenitiesData.find(
              (amenity: any) => amenity.name.toLowerCase().includes(item.name.toLowerCase())
            )?.value;

            const isValuePresent = Array.isArray(amenityValue) && amenityValue.length > 0;

            const showTooltip = isValuePresent && amenityValue.length > 1;

            return (
              <div key={item.name} className="flex items-center space-x-3">
                <i className={`text-3xl las ${item.icon} ${isPresent ? 'text-neutral-700' : 'text-neutral-400 '}`}></i>
                <span
                  className={`font-semibold ${isPresent ? 'text-neutral-700' : 'text-neutral-400 line-through'} ${showTooltip ? 'cursor-pointer' : ''}`}
                  title={showTooltip ? amenityValue.join(", ") : ""}
                >
                  {item.name}
                  {isValuePresent ? showTooltip ? ` (${amenityValue[0]}..)` : ` (${amenityValue[0]})` : ""}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    );
  };


  const [activeTab, setActiveTab] = useState<string>('Security & Safety');

  const renderSection4 = () => {

    const tabs: string[] = ['Security & Safety', 'Policies', 'Accessibility'];

    const features: { [key: string]: string[] } = {
      'Security & Safety': [
        'Smoke detectors',
        'Carbon monoxide detector',
        'First aid kit',
        'Medical emergency contact',
        'Police emergency contact',
        'Emergency exit route',
        'Window guards',
        'Fire extinguisher',
        'Laptop safe box',
        'Safe deposit'
      ],
      Policies: [
        'No smoking rooms facilities',
        'Smoking allowed',
        'Designated smoking area',
        'Pets allowed',
        'No pets allowed',
        'Pets accepted under request',
        'Parties allowed',
        'No parties allowed'
      ],
      Accessibility: [
        'Wheelchair access',
        'Handicapped rooms facilities',
        'Elevator',
        'Braille Elevator',
        'Accessible path of travel',
        'Family friendly',
        'Middle term stay',
        'Pets friendly'
      ],
    };

    const backendDataMapping: { [key: string]: string } = {
      'Security & Safety': 'security_and_safety',
      Policies: 'policies',
      Accessibility: 'accessibility',
    };

    const backendKey = backendDataMapping[activeTab];
    const backendData: string[] = propertyDetails?.[backendKey] || [];
    const knownFeatures = features[activeTab];

    // Anything stored on the property but missing from the curated list above is
    // still shown, so a newly added backend value never silently disappears here.
    const extraFeatures = backendData.filter(
      (item: string, index: number) =>
        item &&
        !knownFeatures.some((f) => f.toLowerCase() === String(item).toLowerCase()) &&
        backendData.findIndex((other: string) => String(other).toLowerCase() === String(item).toLowerCase()) === index
    );

    const displayFeatures = [...knownFeatures, ...extraFeatures];

    return (
      <div className="listingSection__wrap_rm_p shadow-md">
        <div className="flex border-b" style={{ background: "#ECECEC", height: "70px" }}>
          {tabs.map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`w-full py-3 px-4 md:pl-1 text-center ${activeTab === tab
                ? 'text-[#0c586E] !bg-white text-xl leading-[1.35rem]'
                : 'text-gray-500 hover:text-black hover:bg-white-400 text-xl darkTitleForHeader'
                }`}
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                width: '100%',
              }}
            >
              {tab}
            </button>
          ))}
        </div>


        <div className="grid grid-cols-1 xl:grid-cols-2 gap-6 text-sm text-neutral-700 dark:text-neutral-300 p-8 pl-4 md:pl-9">
          {displayFeatures.map((feature: string) => {
            const isPresent = backendData.some(
              (item: any) => item?.toLowerCase() === feature.toLowerCase()
            );

            return (
              <div key={feature} style={isPresent ? {} : { display: 'none' }} className="flex items-center space-x-3">
                <i
                  className="las la-arrow-circle-right la-2x"
                  style={isPresent ? { color: "#0c586E" } : { color: "#dadada", display: 'none' }}
                ></i>
                <span
                  className={`font-semibold ${isPresent ? "text-neutral-700" : "text-neutral-400 line-through hidden"
                    }`}
                >
                  {feature}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const [activTab, setActivTab] = useState<string>('Cancellation Policy');

  const renderSection5 = () => {

    const tabs: string[] = ['Cancellation Policy', 'House Rules'];

    return (
      <div className="listingSection__wrap_rm_p shadow-md bg-white">
        <div className="flex border-b" style={{ background: "#ECECEC", height: "70px" }}>
          {tabs.map((tab) => (
            <button
              key={tab}
              onClick={() => setActivTab(tab)}
              className={`w-full py-3 px-4 text-center ${activTab === tab
                ? 'text-[#0c586E] !bg-white text-xl !leading-[1.35rem]'
                : 'text-gray-500 hover:text-black hover:bg-white-400 text-xl darkTitleForHeader'
                } `}
            >
              {tab}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 xl:grid-cols-1 gap-6 text-sm text-neutral-700 dark:text-neutral-300 p-8 pl-4 md:pl-9 bg-white">
          {activTab == "House Rules" &&
            propertyDetails?.house_rules?.split('\n').map((rule, index) => (
              rule && <div key={index} className="flex items-center space-x-3">
                <i className="las la-arrow-circle-right la-2x" style={{ color: '#0c586E' }}></i>
                <span className="font-semibold text-neutral-700">
                  {rule.replace(/^-/, '').trim()}
                </span>
              </div>
            ))
          }
          {activTab == "Cancellation Policy" &&
            (locale === "fr" && propertyDetails?.cancellation_policy_fr
              ? propertyDetails.cancellation_policy_fr
              : propertyDetails?.cancellation_policy
            )?.split('\n').map((policy, index) => (
              policy && <div key={index} className="flex items-center space-x-3">
                <i className="las la-arrow-circle-right la-2x" style={{ color: '#0c586E' }}></i>
                <span className="font-semibold text-neutral-700">
                  {policy.replace(/^-/, '').trim()}
                </span>
              </div>
            ))
          }
        </div>


      </div>
    );
  };


  /* ---- Date picker helpers ---- */
  const DAY_LETTERS = locale === "fr"
    ? ["D", "L", "M", "M", "J", "V", "S"]
    : ["S", "M", "T", "W", "T", "F", "S"];
  const today = useMemo(() => {
    const d = new Date();
    d.setHours(0, 0, 0, 0);
    return d;
  }, []);

  const calNextMonth = (y: number, m: number) =>
    m === 11 ? { year: y + 1, month: 0 } : { year: y, month: m + 1 };
  const calPrevMonth = (y: number, m: number) =>
    m === 0 ? { year: y - 1, month: 11 } : { year: y, month: m - 1 };
  const calSecond = calNextMonth(calBaseMonth.year, calBaseMonth.month);
  const calDaysIn = (y: number, m: number) => new Date(y, m + 1, 0).getDate();
  const calFirstDow = (y: number, m: number) => new Date(y, m, 1).getDay();
  const calSameDay = (a: Date, b: Date) =>
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate();
  const calInRange = (d: Date) => {
    if (!startDate || !endDate) return false;
    return d > startDate && d < endDate;
  };
  const calIsPast = (d: Date) => d < today;
  const calIsBlocked = (d: Date) =>
    blockedDates.some((bd) => calSameDay(bd, d));

  const calFmtIso = (d: Date) => {
    const yy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return `${yy}-${mm}-${dd}`;
  };

  const calHandleDayClick = (d: Date) => {
    if (calIsPast(d) || calIsBlocked(d)) return;
    if (dateSelecting === "start") {
      setStartDate(d);
      setEndDate(null);
      setDateSelecting("end");
    } else {
      if (d <= startDate!) {
        setStartDate(d);
        setEndDate(null);
        setDateSelecting("end");
      } else {
        setEndDate(d);
        setDateSelecting("start");
        setShowDatePicker(false);
        CalculateRate(startDate, d, numberOfPerson);
      }
    }
  };

  const calBuildCells = (y: number, m: number): (Date | null)[] => {
    const cells: (Date | null)[] = [];
    const fd = calFirstDow(y, m);
    for (let i = 0; i < fd; i++) cells.push(null);
    for (let d = 1; d <= calDaysIn(y, m); d++) cells.push(new Date(y, m, d));
    while (cells.length % 7 !== 0) cells.push(null);
    return cells;
  };

  const calFmtMonthYear = (y: number, m: number) =>
    new Date(y, m, 1).toLocaleDateString(locale === "fr" ? "fr-FR" : "en-US", {
      month: "long",
      year: "numeric",
    });

  const fmtDisplayDate = (d: Date) =>
    d.toLocaleDateString(locale === "fr" ? "fr-FR" : "en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });

  // Close date picker when clicking outside
  useEffect(() => {
    if (!showDatePicker) return;
    const handleClick = (e: MouseEvent) => {
      if (datePickerRef.current && !datePickerRef.current.contains(e.target as Node)) {
        setShowDatePicker(false);
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [showDatePicker]);

  // Close guest picker when clicking outside
  useEffect(() => {
    if (!showGuestPicker) return;
    const handleClick = (e: MouseEvent) => {
      if (guestPickerRef.current && !guestPickerRef.current.contains(e.target as Node)) {
        setShowGuestPicker(false);
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [showGuestPicker]);

  const GUEST_ROWS = [
    { key: "adults", label: t("common.adults"), desc: t("common.adultsDesc") },
    { key: "children", label: t("common.children"), desc: t("common.childrenDesc") },
    { key: "infants", label: t("common.infants"), desc: t("common.infantsDesc") },
  ] as const;

  const getGuestValue = (key: string): number => {
    switch (key) {
      case "adults": return numberOfPerson;
      case "children": return guestChildrenInputValue;
      case "infants": return guestInfantsInputValue;
      default: return 0;
    }
  };

  const setGuestValue = (key: string, value: number) => {
    const v = Math.max(0, value);
    switch (key) {
      case "adults": setNumberOfPerson(v); break;
      case "children": setGuestChildrenInputValue(v); break;
      case "infants": setGuestInfantsInputValue(v); break;
    }
  };

  const fmtGuestsSummary = () => {
    const parts: string[] = [];
    if (numberOfPerson > 0) parts.push(`${numberOfPerson} ${numberOfPerson !== 1 ? t("listingStayDetail.adults") : t("listingStayDetail.adult")}`);
    if (guestChildrenInputValue > 0) parts.push(`${guestChildrenInputValue} ${guestChildrenInputValue !== 1 ? t("listingStayDetail.children") : t("listingStayDetail.child")}`);
    if (guestInfantsInputValue > 0) parts.push(`${guestInfantsInputValue} ${guestInfantsInputValue !== 1 ? t("listingStayDetail.infants") : t("listingStayDetail.infant")}`);
    return parts.length > 0 ? parts.join(", ") : t("listingStayDetail.addGuests");
  };

  const renderCalMonth = (y: number, m: number) => {
    const cells = calBuildCells(y, m);
    const rows: (Date | null)[][] = [];
    for (let i = 0; i < cells.length; i += 7) rows.push(cells.slice(i, i + 7));

    return (
      <div className="flex-1">
        <p
          className="text-[12px] leading-[24px] text-[#01152E] text-center m-0"
          style={{ fontFamily: "Poppins, sans-serif", fontWeight: 500 }}
        >
          {calFmtMonthYear(y, m)}
        </p>
        <div className="grid grid-cols-7 mt-[8px]">
          {DAY_LETTERS.map((letter, i) => (
            <div key={i} className="flex justify-center p-[4px]">
              <span
                className="text-[8px] uppercase text-[#445162]"
                style={{ fontFamily: "Poppins, sans-serif", fontWeight: 500 }}
              >
                {letter}
              </span>
            </div>
          ))}
        </div>
        <div className="flex flex-col gap-[4px] mt-[4px]">
          {rows.map((row, ri) => (
            <div key={ri} className="grid grid-cols-7">
              {row.map((date, ci) => {
                if (!date) return <div key={ci} className="h-[24px]" />;
                const isStart = !!(startDate && calSameDay(date, startDate));
                const isEnd = !!(endDate && calSameDay(date, endDate));
                const ranged = calInRange(date);
                const past = calIsPast(date);
                const blocked = calIsBlocked(date);

                let rangeBg: "full" | "right" | "left" | "none" = "none";
                if (ranged) rangeBg = "full";
                else if (isStart && endDate) rangeBg = "right";
                else if (isEnd && startDate) rangeBg = "left";

                return (
                  <div key={ci} className="relative flex items-center justify-center h-[24px]">
                    {rangeBg === "full" && <div className="absolute inset-0 bg-[#faf7f1]" />}
                    {rangeBg === "right" && <div className="absolute inset-y-0 left-1/2 right-0 bg-[#faf7f1]" />}
                    {rangeBg === "left" && <div className="absolute inset-y-0 left-0 right-1/2 bg-[#faf7f1]" />}
                    <button
                      onClick={() => calHandleDayClick(date)}
                      disabled={past || blocked}
                      className={`relative flex items-center justify-center w-[24px] h-[24px] shrink-0 border-0 p-0 ${past || blocked ? "cursor-default" : "cursor-pointer"
                        }`}
                      style={{
                        background: isStart || isEnd ? "#B88333" : "transparent",
                        borderRadius: isStart || isEnd ? "50%" : undefined,
                      }}
                    >
                      <span
                        className="text-[10px] text-center"
                        style={{
                          fontFamily: "Poppins, sans-serif",
                          fontWeight: 500,
                          color:
                            isStart || isEnd
                              ? "#ffffff"
                              : past || blocked
                                ? "#d6d6d6"
                                : "#01152E",
                        }}
                      >
                        {date.getDate()}
                      </span>
                    </button>
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>
    );
  };

  const renderSidebarMap = () => {
    const properties = [
      { id: 1, lat: 19.114111373215245, lng: 73.03439074306638, title: "Property 1" },
      { id: 2, lat: 19.115, lng: 73.035, title: "Property 2" },
      { id: 3, lat: 19.116, lng: 73.036, title: "Property 3" },
    ];
    interface MarkerProps {
      lat: number;
      lng: number;
      text: string;
    }

    const Marker: React.FC<MarkerProps> = ({ text }) => (
      <div style={{ transform: 'translate(-50%, -100%)' }}>
        <img
          src="https://maps.gstatic.com/mapfiles/api-3/images/spotlight-poi2_hdpi.png"
          alt="Marker"
          style={{ width: '22px', height: '35px' }}
        />
        {/* {text && <div style={{ color: 'red', fontWeight: 'bold' }}>{text}</div>} */}
      </div>
    );
    const defaultProps = {
      center: {
        lat: propertyDetails?.coordinates?.coordinates[0] || 19.114111373215245,
        lng: propertyDetails?.coordinates?.coordinates[1] || 73.03439074306638,
      },
      zoom: 11
    };
    // const centerLocation = {
    //   lat: 19.114111373215245,
    //   lng: 73.03439074306638,
    // };
    const mapStyles = [
      {
        "elementType": "geometry",
        "stylers": [{ "color": "#F6F6F4" }]
      },
      {
        "elementType": "labels.text.fill",
        "stylers": [{ "color": "#523735" }]
      },
      {
        "elementType": "labels.text.stroke",
        "stylers": [{ "color": "#f5f1e6" }]
      },
      {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [{ "color": "#D0ECEF" }]
      },
      {
        "featureType": "landscape.natural",
        "elementType": "geometry",
        "stylers": [{ "color": "#F6F6F4" }]
      },
      {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [{ "color": "#E2F2DA" }]
      },
      {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": [{ "color": "#ffffff" }]
      },
      {
        "featureType": "administrative",
        "elementType": "labels.text.fill",
        "stylers": [{ "color": "#444444" }]
      },
      {
        featureType: "administrative",
        elementType: "geometry",
        stylers: [
          {
            color: "#e0e0e0",
          },
        ],
      },
      { "elementType": "labels.text.fill", "stylers": [{ "color": "#4a4a4a", "fontWeight": "bold" }] },
    ]
    return (
      <div className="listingSectionSidebar__wrap shadow-xl shadow-md bg-white">
        <h2 className="text-2xl darkTitleForHeader inline-block">Location</h2>
        <hr className="-mx-6" />
        <div className="grid grid-cols-1 h-[300px]">
          <div className="aspect-w-5 aspect-h-5 sm:aspect-h-3 ring-1 ring-black/10 rounded-xl z-0">
            <div className="rounded-xl overflow-hidden z-0">
              <GoogleMapReact
                options={{
                  styles: mapStyles,
                  gestureHandling: 'cooperative',
                  scrollwheel: false,
                  fullscreenControl: false,
                  mapTypeId: 'roadmap',
                  disableDefaultUI: true
                }}
                defaultCenter={defaultProps.center}
                defaultZoom={defaultProps.zoom}
                // bootstrapURLKeys={{key:"AIzaSyDE4YXJP-Oq9uXDySWbJBOBtwej5bdrw1A"}}
                bootstrapURLKeys={{ key: "AIzaSyDE4YXJP-Oq9uXDySWbJBOBtwej5bdrw1A" }}
              >
                <Marker
                  lat={defaultProps.center.lat}
                  lng={defaultProps.center.lng}
                  text={propertyDetails?.location || ""}
                />
              </GoogleMapReact>
            </div>
          </div>
        </div>
      </div>
    );
  };


  const handleImageError = (e: any, item: any) => {
    e.target.onerror = null;
    e.target.src = item;
  }

  // Safety & Security is rendered from the property's own security_and_safety
  // values. Only four of the ten values in use have a dedicated icon; the rest
  // fall back to a tick so the column stays aligned.
  const SAFETY_ICONS: Record<string, string> = {
    "smoke detectors": smokeDetectorIcon,
    "first aid kit": firstAidKitIcon,
    "carbon monoxide detector": carbonMonoxideIcon,
    "fire extinguisher": fireExtinguisherIcon,
  };

  const safetyItems: { label: string; icon: string }[] = (
    propertyDetails?.security_and_safety || []
  )
    .filter((value: any) => typeof value === "string" && value.trim())
    .map((value: string) => ({
      label: value.trim(),
      icon: SAFETY_ICONS[value.toLowerCase().trim()] || checkCircleGold,
    }));

  // House Rules comes from `policies`, which holds both permissive and
  // prohibitive values ("Smoking allowed" and "No smoking rooms facilities").
  // The only icons available are negative (no-smoking, no-parties), so they are
  // used for prohibitions only — a no-smoking sign beside "Smoking allowed"
  // would contradict the label. The paw is topic-neutral, so it covers all pet
  // rules; anything else falls back to a tick.
  const getPolicyIcon = (value: string): string => {
    const policy = value.toLowerCase().trim();
    const isProhibition = policy.startsWith("no ");
    if (policy.includes("pet")) return pawprintIcon;
    if (policy.includes("smoking")) return isProhibition ? noSmokingIcon : checkCircleGold;
    if (policy.includes("part")) return isProhibition ? noPartiesIcon : checkCircleGold;
    return checkCircleGold;
  };

  const houseRuleItems: { label: string; icon: string }[] = (
    propertyDetails?.policies || []
  )
    .filter((value: any) => typeof value === "string" && value.trim())
    .map((value: string) => ({ label: value.trim(), icon: getPolicyIcon(value) }));

  // Accessibility comes from the property's `accessibility` values (wheelchair
  // access, elevator, family friendly, …). There are no dedicated icons for
  // these, so every row uses the same gold tick — matching the Safety fallback.
  const accessibilityItems: { label: string; icon: string }[] = (
    propertyDetails?.accessibility || []
  )
    .filter((value: any) => typeof value === "string" && value.trim())
    .map((value: string) => ({ label: value.trim(), icon: checkCircleGold }));
  const navigate = useNavigate();

  return (
    <div
      style={{
        background: "#ffffff",
        /* Break out of .container parent to take full viewport width */
        width: "100vw",
        marginLeft: "calc(-50vw + 50%)",
      }}
      className="nc-ListingStayDetailPage"
    >
      {/* Responsive overrides for the many inline-styled blocks below.
          Inline styles can only be overridden from a stylesheet with
          !important, so the media queries here are marked as such. */}
      <style>{`
        /* Below the desktop breakpoint the sidebar (and its absolutely-
           positioned dropdowns) is hidden, so clipping horizontal overflow here
           is safe and stops the page from ever scrolling sideways. */
        @media (max-width: 1023px) {
          .nc-ListingStayDetailPage { overflow-x: hidden; }
        }
        @media (max-width: 1279px) {
          .eu-trust-banner { padding-left: 40px !important; padding-right: 40px !important; }
        }
        @media (max-width: 1023px) {
          .eu-amenities-grid { grid-template-columns: repeat(3, 1fr) !important; }
        }
        @media (max-width: 767px) {
          .eu-trust-banner {
            flex-direction: column !important;
            gap: 40px !important;
            padding: 48px 16px 64px !important;
          }
          .eu-reviews-grid { grid-template-columns: 1fr !important; gap: 32px !important; }
          .eu-safety-rules { flex-direction: column !important; gap: 32px !important; padding: 32px 0 !important; }
          .eu-safety-rules-divider { display: none !important; }
        }
        @media (max-width: 639px) {
          .eu-amenities-grid { grid-template-columns: repeat(2, 1fr) !important; }
        }
        /* Below desktop the booking card is full width, so its absolutely-
           positioned popovers must stay within it instead of overhanging. */
        @media (max-width: 1023px) {
          .eu-fees-popup { left: 0 !important; right: auto !important; width: 260px !important; max-width: 80vw !important; }
        }
        /* Only stretch the datepicker to the full-width card / stack its months
           on real phones. On tablet the card is ~700px wide, so a full-width
           single month would spread the day cells far apart — keep the fixed
           420px two-month layout there (same as desktop). */
        @media (max-width: 767px) {
          .eu-datepicker-panel {
            left: 0 !important;
            right: 0 !important;
            width: auto !important;
          }
          .eu-datepicker-months { flex-direction: column !important; }
        }
      `}</style>
      {/* Peek-style image carousel — full bleed, sliding, infinite loop */}
      {images.length > 0 && (() => {
        // Build extended strip: [lastImg, ...allImages, firstImg]
        // trackIndex = carouselIndex + 1 (offset by the prepended clone)
        // On transitionEnd at clone positions, instantly jump to the real image (no transition).
        const extImages = images.length > 1
          ? [images[images.length - 1], ...images, images[0]]
          : images;
        const trackIndex = images.length > 1 ? carouselIndex + 1 : 0;

        const handleTransitionEnd = () => {
          if (images.length <= 1) return;
          const track = carouselTrackRef.current;
          if (!track) return;
          if (carouselIndex < 0) {
            // Slid to prepended clone (left of first) → jump to real last
            track.style.transition = "none";
            setCarouselIndex(images.length - 1);
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                if (track) track.style.transition = "transform 0.4s ease";
              });
            });
          } else if (carouselIndex >= images.length) {
            // Slid to appended clone (right of last) → jump to real first
            track.style.transition = "none";
            setCarouselIndex(0);
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                if (track) track.style.transition = "transform 0.4s ease";
              });
            });
          }
        };

        return (
          <div
            className="relative overflow-hidden"
            style={{
              width: "100vw",
              marginLeft: "calc(-50vw + 50%)",
              height: "clamp(250px, 28vw, 400px)",
            }}
          >
            <div
              ref={carouselTrackRef}
              onTransitionEnd={handleTransitionEnd}
              className="flex items-stretch gap-[20px] absolute top-0 h-full"
              style={{
                transition: "transform 0.4s ease",
                transform: `translateX(calc(50vw - clamp(250px, 28vw, 400px) * 0.75 - ${trackIndex} * (clamp(250px, 28vw, 400px) * 1.5 + 20px)))`,
              }}
            >
              {extImages.map((img, idx) => (
                <div
                  key={idx}
                  className="flex-shrink-0 rounded-[10px] overflow-hidden relative"
                  style={{
                    width: "calc(clamp(250px, 28vw, 400px) * 1.5)",
                    height: "100%",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    const realIndex = (idx - 1 + images.length) % images.length;
                    setGalleryInitialIndex(realIndex);
                    setGalleryOpen(true);
                  }}
                >
                  <img
                    className="w-full h-full object-cover"
                    src={getImageVariantUrl(img, "_compress")}
                    onError={(e) => handleImageError(e, img)}
                    alt={propertyDetails?.title || ""}
                    loading={idx <= 2 ? "eager" : "lazy"}
                  />
                </div>
              ))}
            </div>

            {/* Left arrow — opens the full image gallery at the current image */}
            {images.length > 1 && (
              <button
                onClick={() => {
                  const realIndex = ((carouselIndex % images.length) + images.length) % images.length;
                  setGalleryInitialIndex(realIndex);
                  setGalleryOpen(true);
                }}
                className="absolute left-[40px] top-1/2 -translate-y-1/2 flex items-center justify-center w-[30px] h-[34px] rounded-[4px] bg-white/80 hover:bg-white cursor-pointer z-10 p-0 border-none"
                style={{ boxShadow: "0px 0px 2px rgba(0,0,0,0.25)" }}
              >
                <svg width="8" height="14" viewBox="0 0 8 14" fill="none">
                  <path d="M7 1L1 7L7 13" stroke="#01152E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
            )}

            {/* Right arrow — opens the full image gallery at the current image */}
            {images.length > 1 && (
              <button
                onClick={() => {
                  const realIndex = ((carouselIndex % images.length) + images.length) % images.length;
                  setGalleryInitialIndex(realIndex);
                  setGalleryOpen(true);
                }}
                className="absolute right-[40px] top-1/2 -translate-y-1/2 flex items-center justify-center w-[30px] h-[34px] rounded-[4px] bg-white/80 hover:bg-white cursor-pointer z-10 p-0 border-none"
                style={{ boxShadow: "0px 0px 2px rgba(0,0,0,0.25)" }}
              >
                <svg width="8" height="14" viewBox="0 0 8 14" fill="none">
                  <path d="M1 1L7 7L1 13" stroke="#01152E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
            )}
          </div>
        );
      })()}

      <main className="relative z-10 flex flex-col lg:flex-row gap-8 lg:gap-[55px] px-4 sm:px-8 xl:px-[120px]" style={{ marginTop: 40 }}>
        {/* LEFT COLUMN */}
        <div className="flex-1 min-w-0 space-y-8 lg:space-y-10">
          {/* Title row — property name, location, share, wishlist */}
          <div className="flex items-start justify-between gap-6 sm:gap-6">
            {/* Left: Title + Location */}
            <div className="min-w-0 flex-1" style={{ display: "flex", flexDirection: "column", gap: 0 }}>
              <h1
                className="text-[22px] leading-[30px] sm:text-[28px] sm:leading-[40px]"
                style={{
                  fontFamily: "Poppins, sans-serif",
                  fontWeight: 600,
                  letterSpacing: "0.56px",
                  color: "#01152E",
                  margin: 0,
                }}
              >
                {propertyDetails?.title || ""}
              </h1>
              <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                <div
                  style={{
                    width: 9,
                    height: 11,
                    flexShrink: 0,
                    backgroundColor: "#B88333",
                    WebkitMaskImage: `url(${pinIcon})`,
                    maskImage: `url(${pinIcon})`,
                    WebkitMaskSize: "contain",
                    maskSize: "contain",
                    WebkitMaskRepeat: "no-repeat",
                    maskRepeat: "no-repeat",
                    WebkitMaskPosition: "center",
                    maskPosition: "center",
                  }}
                />
                <span
                  style={{
                    fontFamily: "Poppins, sans-serif",
                    fontWeight: 400,
                    fontSize: 14,
                    lineHeight: "24px",
                    color: "#445162",
                  }}
                >
                  {propertyDetails?.location || ""}
                </span>
              </div>

            </div>

            {/* Right: Share + Wishlist — icon-only column on mobile (wishlist on top,
                share below), row with labels on ≥sm screens. */}
            <div className="flex flex-col-reverse items-end gap-3 sm:flex-row sm:items-center sm:gap-4 shrink-0" style={{ marginTop: 6 }}>
              <button
                onClick={() => {
                  if (navigator.share) {
                    navigator.share({ title: propertyDetails?.title, url: window.location.href });
                  } else {
                    navigator.clipboard.writeText(window.location.href);
                  }
                }}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  padding: 0,
                }}
              >
                <img src={shareIcon} alt={t("listingStayDetail.share")} style={{ width: 14, height: 15 }} />
                <span className="hidden sm:inline" style={{ fontFamily: "Poppins, sans-serif", fontWeight: 500, fontSize: 12, lineHeight: "24px", color: "#01152E" }}>
                  {t("listingStayDetail.share")}
                </span>
              </button>
              <div className="hidden sm:block" style={{ width: 1, height: 8, backgroundColor: "#01152E" }} />
              <button
                onClick={() => toggleWishlist(id || undefined)}
                title={isSaved(id || undefined) ? t("listingStayDetail.removeFromWishlist") : t("listingStayDetail.saveToWishlist")}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  padding: 0,
                }}
              >
                {isSaved(id || undefined) ? (
                  /* Same heart as wishlist-icon.svg, filled to show the saved state. */
                  <svg width={17} height={15} viewBox="0 0 17 15" fill="none">
                    <path
                      d="M12.5811 0.799805C14.573 0.800018 16.2 2.43095 16.2002 4.45605V4.54395C16.2 6.13031 15.1961 7.97414 13.7549 9.73926C12.5166 11.2559 11.0457 12.6054 9.9082 13.5264L9.44336 13.8936C9.18193 14.0928 8.85194 14.2002 8.5 14.2002C8.14198 14.2002 7.81241 14.0926 7.56055 13.8965L7.55664 13.8936C6.37858 12.9871 4.66009 11.4723 3.24512 9.73926C1.80394 7.97414 0.799981 6.13031 0.799805 4.54395V4.45605C0.800029 2.43095 2.42696 0.800018 4.41895 0.799805C5.57767 0.799805 6.67112 1.36105 7.35156 2.31055L7.35254 2.31152L7.85059 3.00488L8.5 3.90918L9.14941 3.00488L9.64746 2.31152L9.64844 2.31055C10.3289 1.36105 11.4223 0.799805 12.5811 0.799805Z"
                      fill="#01152E"
                      stroke="#01152E"
                      strokeWidth="1.6"
                    />
                  </svg>
                ) : (
                  <img src={wishlistIcon} alt="" style={{ width: 17, height: 15 }} />
                )}
                <span className="hidden sm:inline" style={{ fontFamily: "Poppins, sans-serif", fontWeight: 500, fontSize: 12, lineHeight: "24px", color: "#01152E" }}>
                  {isSaved(id || undefined) ? t("listingStayDetail.saved") : t("common.wishlist")}
                </span>
              </button>
            </div>
          </div>

          {/* Type/status badges + stats on the left; the primary-residence
              night counter to the right on desktop and stacked below the stats
              on mobile. Grouping badges + stats in a left column keeps the stats
              line directly under the badges — the taller counter no longer
              pushes it down on desktop. */}
          <div className="flex flex-col 2xl:flex-row 2xl:items-start 2xl:justify-between 2xl:gap-6" style={{ marginTop: 28 }}>
            {/* Left column: type/status badges, then the bed/bath/toilet/sleeps line */}
            <div>
              {/* Property type tags + licence number (to the right of the status pills) */}
              <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 8 }}>
                {[
                  propertyDetails?.type_of_unit,
                  propertyDetails?.status_of_unit,
                ]
                  .filter(Boolean)
                  .map((tag, i) => (
                    <div
                      key={i}
                      style={{
                        backgroundColor: "#ffffff",
                        border: "1px solid #d6d6d6",
                        borderRadius: 20,
                        padding: "8px 18px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <span
                        style={{
                          fontFamily: "Poppins, sans-serif",
                          fontWeight: 500,
                          fontSize: 12,
                          lineHeight: "24px",
                          color: "#01152E",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {tag}
                      </span>
                    </div>
                  ))}
                {propertyDetails?.residence_licence_number && (
                  <span
                    className="mt-2 sm:mt-0"
                    style={{
                      fontFamily: "Poppins, sans-serif",
                      fontWeight: 400,
                      fontSize: 13,
                      lineHeight: "20px",
                      color: "#445162",
                      marginLeft: 4,
                      whiteSpace: "nowrap",
                    }}
                  >
                    {t("listingStayDetail.licenceNo")}{" "}
                    <span style={{ fontWeight: 600, color: "#01152E" }}>
                      {propertyDetails?.residence_licence_number}
                    </span>
                  </span>
                )}
              </div>

              {/* Property stats row */}
              <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", columnGap: 16, rowGap: 8, marginTop: 16 }}>
                {[
                  { icon: bedIcon, iconW: 19, iconH: 14, value: propertyDetails?.bedrooms ?? 1, label: "Bedroom", singularKey: "listingStayDetail.bedroom", pluralKey: "payDone.bedrooms" },
                  { icon: bathIcon, iconW: 14, iconH: 14, value: propertyDetails?.bathrooms ?? 1, label: "Bathroom", singularKey: "listingStayDetail.bathroom", pluralKey: "payDone.bathrooms" },
                  { icon: kitchenIcon, iconW: 12, iconH: 14, value: propertyDetails?.toilets ?? 1, label: "Toilet", singularKey: "listingStayDetail.toilet", pluralKey: "payDone.toilets" },
                  { icon: sleepsIcon, iconW: 18, iconH: 14, value: propertyDetails?.sleeps ?? 2, label: "Sleeps", singularKey: "payDone.sleeps", pluralKey: "payDone.sleeps" },
                ].map((stat, i, arr) => (
                  <Fragment key={i}>
                    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                      <img src={stat.icon} alt="" style={{ width: stat.iconW, height: stat.iconH }} />
                      <span
                        style={{
                          fontFamily: "Poppins, sans-serif",
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: "24px",
                          color: "#445162",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {stat.label === "Sleeps"
                          ? `${t("payDone.sleeps")} ${stat.value}`
                          : `${stat.value} ${stat.value > 1 ? t(stat.pluralKey) : t(stat.singularKey)}`}
                      </span>
                    </div>
                    {i < arr.length - 1 && (
                      <div style={{ width: 1, height: 14, backgroundColor: "#d6d6d6" }} />
                    )}
                  </Fragment>
                ))}
              </div>
            </div>

            {/* Night counter — right of the badges/stats on desktop, below them on mobile */}
            {bookedNightsData && (
              <div className="mt-7 2xl:mt-0 -ml-4 2xl:ml-0 flex-shrink-0">
                <BookedNightsCounter data={bookedNightsData} year={new Date().getFullYear()} />
              </div>
            )}
          </div>

          {/* Separator */}
          <div style={{ width: "100%", height: 1, backgroundColor: "#d6d6d6", marginTop: 28 }} />

          {/* Reviews row — hidden entirely until this property has a published
              review, so a new listing does not advertise a rating of zero. */}
          {reviewsSummary.count > 0 && reviewsSummary.average != null && (
            <>
              {/* Clicking the stars or the count jumps to the reviews section. */}
              <div
                role="button"
                tabIndex={0}
                onClick={scrollToReviews}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    scrollToReviews();
                  }
                }}
                style={{ display: "inline-flex", alignItems: "center", gap: 10, marginTop: 16, cursor: "pointer" }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                  {renderStars(reviewsSummary.average, "summary", 21, 19, "#B88333", 6)}
                  <span
                    style={{
                      fontFamily: "Poppins, sans-serif",
                      fontWeight: 600,
                      fontSize: 20,
                      lineHeight: "24px",
                      letterSpacing: "-0.4px",
                      color: "#445162",
                    }}
                  >
                    {reviewsSummary.average.toFixed(1)}
                  </span>
                </div>
                <div style={{ width: 1, height: 8, backgroundColor: "#d6d6d6" }} />
                <span
                  style={{
                    fontFamily: "Poppins, sans-serif",
                    fontWeight: 600,
                    fontSize: 12,
                    lineHeight: "24px",
                    letterSpacing: "1.2px",
                    color: "#01152E",
                    textTransform: "uppercase",
                    textDecoration: "underline",
                    textUnderlineOffset: "2px",
                  }}
                >
                  {reviewsSummary.count} {t("listingStayDetail.reviews")}
                </span>
              </div>

              {/* Separator */}
              <div style={{ width: "100%", height: 1, backgroundColor: "#d6d6d6", marginTop: 16 }} />
            </>
          )}

          {/* Home Details */}
          <h2
            style={{
              fontFamily: "Poppins, sans-serif",
              fontWeight: 600,
              fontSize: 18,
              lineHeight: "24px",
              letterSpacing: "0.36px",
              color: "#01152E",
              margin: 0,
              marginTop: 28,
            }}
          >
            {t("listingStayDetail.homeDetails")}
          </h2>
          {(() => {
            const desc =
              propertyDetails?.description?.[locale] || propertyDetails?.description?.en || "";
            const charLimit = 200;
            const needsTruncation = desc.length > charLimit;
            const displayText = showFullDescription || !needsTruncation ? desc : desc.slice(0, charLimit).trimEnd();
            return (
              <div style={{ marginTop: 12 }}>
                <p
                  style={{
                    fontFamily: "Roboto, sans-serif",
                    fontWeight: 400,
                    fontSize: 16,
                    lineHeight: "24px",
                    color: "#445162",
                    margin: 0,
                    whiteSpace: "pre-line",
                  }}
                >
                  {displayText}
                  {!showFullDescription && needsTruncation && "..."}
                </p>
                {needsTruncation && (
                  <button
                    onClick={() => setShowFullDescription(!showFullDescription)}
                    style={{
                      background: "none",
                      border: "none",
                      padding: 0,
                      cursor: "pointer",
                      marginTop: 8,
                      fontFamily: "Poppins, sans-serif",
                      fontWeight: 600,
                      fontSize: 12,
                      lineHeight: "24px",
                      letterSpacing: "1.2px",
                      color: "#01152E",
                      textTransform: "uppercase",
                      textDecoration: "underline",
                      textUnderlineOffset: "2px",
                    }}
                  >
                    {showFullDescription
                      ? t("listingStayDetail.showLess")
                      : t("listingStayDetail.showMore")}
                  </button>
                )}
              </div>
            );
          })()}

          {/* Separator */}
          <div style={{ width: "100%", height: 1, backgroundColor: "#d6d6d6", marginTop: 28 }} />

          {/* Amenities */}
          <h2
            style={{
              fontFamily: "Poppins, sans-serif",
              fontWeight: 600,
              fontSize: 18,
              lineHeight: "24px",
              letterSpacing: "0.36px",
              color: "#01152E",
              margin: 0,
              marginTop: 28,
            }}
          >
            {t("listingStayDetail.amenities")}
          </h2>
          {(() => {
            // Amenities_demos is a fixed UI checklist (constant.ts), not
            // per-property data, so its labels are translated here rather
            // than left as raw English from the data file.
            const AMENITY_NAME_KEYS: Record<string, string> = {
              "Internet": "internet",
              "Parking": "parking",
              "Baby Cot": "babyCot",
              "Swimming Pool": "swimmingPool",
              "Washing Machine": "washingMachine",
              "Iron & Ironing Board": "ironBoard",
              "Dishwasher": "dishwasher",
              "Drying Machine": "dryingMachine",
              "Linen & Towels": "linenTowels",
              "Satellite TV": "satelliteTV",
              "Terrace": "terrace",
              "Heating": "heating",
              "Garden": "garden",
              "Cable TV": "cableTV",
              "Air Conditioning": "airConditioning",
            };
            const amenitiesData = propertyDetails?.amenities || [];
            const items = Amenities_demos.map((item) => {
              const match = amenitiesData.find(
                (amenity: any) => amenity.name.toLowerCase().includes(item.name.toLowerCase())
              );
              const isPresent = !!match;
              return { ...item, isPresent };
            });
            return (
              <div
                className="eu-amenities-grid"
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(4, 1fr)",
                  columnGap: 16,
                  rowGap: 16,
                  marginTop: 20,
                }}
              >
                {items.map((item) => (
                  <div key={item.name} style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <i
                      className={`las ${item.icon}`}
                      style={{
                        fontSize: 18,
                        color: "#01152E",
                        width: 18,
                        textAlign: "center",
                        flexShrink: 0,
                      }}
                    />
                    <span
                      style={{
                        fontFamily: "Poppins, sans-serif",
                        fontWeight: 500,
                        fontSize: 14,
                        lineHeight: "20px",
                        color: item.isPresent ? "#01152E" : "#445162",
                        textDecoration: item.isPresent ? "none" : "line-through",
                      }}
                    >
                      {AMENITY_NAME_KEYS[item.name]
                        ? t(`listingStayDetail.amenityNames.${AMENITY_NAME_KEYS[item.name]}`)
                        : item.name}
                    </span>
                  </div>
                ))}
              </div>
            );
          })()}

          {/* Separator below amenities */}
          <div style={{ width: "100%", height: 1, backgroundColor: "#d6d6d6", marginTop: 14 }} />

          {/* Room cards */}
          {(() => {
            const fmtAmenity = (a: PropertySectionAmenity) => {
              if (!a?.name) return "";
              if (a.value && a.value.length > 0) {
                return `${a.name} (${a.value.join(", ")})`;
              }
              return a.name;
            };

            // Column count flexes, tile size doesn't. 245px is the Figma
            // thumbnail width, so the grid fits as many whole tiles as the row
            // allows and adds another column rather than stretching the ones
            // already there. auto-FILL, not auto-fit: auto-fit collapses the
            // empty tracks, which would let two sections stretch across the
            // whole row — exactly what we're avoiding here.
            return propertySections.length > 0 ? (
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(245px, 1fr))",
                  gap: 20,
                  marginTop: 28,
                }}
              >
                {propertySections.map((section) => {
                  // Prefer the curated cover shot; fall back to the first gallery image for that section.
                  const thumb = section.cover_images?.[0] || section.images?.[0];
                  const amenityLabels = (section.amenities || [])
                    .filter((a) => a?.name)
                    .map(fmtAmenity)
                    .filter(Boolean);

                  return (
                    <div key={section._id} style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                    <img
                      src={getImageVariantUrl(thumb, "_compress")}
                      alt={section.title}
                      onError={(e) => handleImageError(e, thumb)}
                      style={{
                        width: "100%",
                        // Ratio, not a fixed height. The column is fluid, so
                        // pairing it with height:168 made the frame (and the
                        // object-fit crop) change at every window size and zoom
                        // level. 245x166 is the thumbnail in Figma — which is
                        // ~3:2, matching the hero carousel and the gallery
                        // modal's 916x610.
                        aspectRatio: "245 / 166",
                        objectFit: "cover",
                        borderRadius: 12,
                      }}
                    />
                    <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                      <span
                        style={{
                          fontFamily: "Poppins, sans-serif",
                          fontWeight: 600,
                          fontSize: 18,
                          lineHeight: "24px",
                          letterSpacing: "0.36px",
                          color: "#01152E",
                        }}
                      >
                        {section.title}
                      </span>
                        {amenityLabels.length > 0 && (
                      <span
                        style={{
                          fontFamily: "Poppins, sans-serif",
                          fontWeight: 400,
                          fontSize: 12,
                          lineHeight: "18px",
                          color: "#445162",
                        }}
                            title={amenityLabels.join(", ")}
                      >
                        {amenityLabels.join(", ")}
                      </span>
                        )}
                    </div>
                  </div>
                );
                })}
              </div>
            ) : null;
          })()}

          {/* Safety & Security + House Rules + Accessibility — single wrapper to
              avoid space-y gaps. Rendered data-driven so any one, two, or all
              three columns show (with dividers only between the columns that
              actually appear), and the horizontal separators never frame an
              empty band. */}
          {(() => {
            const detailSections: { title: string; items: { label: string; icon: string }[] }[] = [
              { title: t("listingStayDetail.safetySecurity"), items: safetyItems },
              { title: t("listingStayDetail.houseRules"), items: houseRuleItems },
              { title: t("listingStayDetail.accessibility"), items: accessibilityItems },
            ].filter((section) => section.items.length > 0);

            if (detailSections.length === 0) return null;

            return (
              <div>
                {/* Top separator — full width */}
                <div style={{ width: "100%", height: 1, backgroundColor: "#d6d6d6" }} />

                {/* Side by side content */}
                <div className="eu-safety-rules" style={{ display: "flex", gap: 0, padding: "40px 0" }}>
                  {detailSections.map((section, index) => (
                    <React.Fragment key={section.title}>
                      {/* Vertical separator between consecutive columns */}
                      {index > 0 && (
                        <div className="eu-safety-rules-divider" style={{ width: 1, backgroundColor: "#d6d6d6", alignSelf: "stretch", margin: "-40px 40px" }} />
                      )}
                      <div style={{ flex: 1 }}>
                        <h3 style={{
                          fontFamily: "Poppins, sans-serif",
                          fontWeight: 600,
                          fontSize: 18,
                          lineHeight: "24px",
                          letterSpacing: "0.36px",
                          color: "#01152E",
                          margin: 0,
                        }}>
                          {section.title}
                        </h3>
                        <div style={{ display: "flex", flexDirection: "column", gap: 16, marginTop: 20 }}>
                          {section.items.map((item) => (
                            <div key={item.label} style={{ display: "flex", alignItems: "center", gap: 10 }}>
                              <img src={item.icon} alt="" style={{ width: 16, height: 16, flexShrink: 0 }} />
                              <span style={{
                                fontFamily: "Poppins, sans-serif",
                                fontWeight: 500,
                                fontSize: 14,
                                lineHeight: "24px",
                                color: "#01152E",
                              }}>
                                {item.label}
                              </span>
                            </div>
                          ))}
                        </div>
                      </div>
                    </React.Fragment>
                  ))}
                </div>

                {/* Bottom separator — full width */}
                <div style={{ width: "100%", height: 1, backgroundColor: "#d6d6d6" }} />
              </div>
            );
          })()}

          {/* Property location map */}
          {propertyDetails?.coordinates?.coordinates && (() => {
            const lat = propertyDetails.coordinates.coordinates[0];
            const lng = propertyDetails.coordinates.coordinates[1];
            const locationMapStyles = [
              { featureType: "administrative", elementType: "labels.text.fill", stylers: [{ color: "#6195a0" }] },
              { featureType: "administrative.province", elementType: "geometry.stroke", stylers: [{ visibility: "off" }] },
              { featureType: "landscape", elementType: "geometry", stylers: [{ lightness: "0" }, { saturation: "0" }, { color: "#F7F1DF" }, { gamma: "1" }] },
              { featureType: "landscape.man_made", elementType: "all", stylers: [{ lightness: "-3" }, { gamma: "1.00" }] },
              { featureType: "landscape.natural.terrain", elementType: "all", stylers: [{ visibility: "off" }] },
              { featureType: "poi", elementType: "all", stylers: [{ visibility: "off" }] },
              { featureType: "poi.park", elementType: "geometry.fill", stylers: [{ color: "#bae5ce" }, { visibility: "on" }] },
              { featureType: "road", elementType: "all", stylers: [{ saturation: -100 }, { lightness: 45 }, { visibility: "simplified" }] },
              { featureType: "road.highway", elementType: "all", stylers: [{ visibility: "simplified" }] },
              { featureType: "road.highway", elementType: "geometry.fill", stylers: [{ color: "#fac9a9" }, { visibility: "simplified" }] },
              { featureType: "road.highway", elementType: "labels.text", stylers: [{ color: "#4e4e4e" }] },
              { featureType: "road.arterial", elementType: "labels.text.fill", stylers: [{ color: "#787878" }] },
              { featureType: "road.arterial", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
              { featureType: "transit", elementType: "all", stylers: [{ visibility: "simplified" }] },
              { featureType: "transit.station.airport", elementType: "labels.icon", stylers: [{ hue: "#0a00ff" }, { saturation: "-77" }, { gamma: "0.57" }, { lightness: "0" }] },
              { featureType: "transit.station.rail", elementType: "labels.text.fill", stylers: [{ color: "#43321e" }] },
              { featureType: "transit.station.rail", elementType: "labels.icon", stylers: [{ hue: "#ff6c00" }, { lightness: "4" }, { gamma: "0.75" }, { saturation: "-68" }] },
              { featureType: "water", elementType: "all", stylers: [{ color: "#eaf6f8" }, { visibility: "on" }] },
              { featureType: "water", elementType: "geometry.fill", stylers: [{ color: "#c7eced" }] },
              { featureType: "water", elementType: "labels.text.fill", stylers: [{ lightness: "-49" }, { saturation: "-53" }, { gamma: "0.79" }] },
            ];
            return (
              <div style={{ marginTop: 40, borderRadius: 12, overflow: "hidden", height: 380, position: "relative" }}>
                {/* Top gradient fade + city name */}
                <div style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  height: 60,
                  background: "linear-gradient(to bottom, #f7f3ec, rgba(246,246,245,0))",
                  zIndex: 10,
                  pointerEvents: "none",
                  borderRadius: "7px 7px 0 0",
                }} />
                <span style={{
                  position: "absolute",
                  top: 14,
                  left: 16,
                  zIndex: 11,
                  fontFamily: "Poppins, sans-serif",
                  fontWeight: 600,
                  fontSize: 18,
                  lineHeight: "24px",
                  color: "#01152E",
                  pointerEvents: "none",
                }}>
                  {propertyDetails?.location || ""}
                </span>
                {/* Custom zoom controls. Native zoomControl stays off; these
                    call setZoom on the map instance, which Google clamps to the
                    map's min/max zoom so users can't zoom in to the exact
                    address. */}
                <div style={{ position: "absolute", top: 14, right: 14, zIndex: 11, display: "flex", flexDirection: "column", gap: 8 }}>
                  <button
                    type="button"
                    aria-label="Zoom in"
                    onClick={() => {
                      const map = locationMapRef.current;
                      if (map) map.setZoom(Math.min((map.getZoom() || 13) + 1, LOCATION_MAP_MAX_ZOOM));
                    }}
                    className="flex items-center justify-center w-[38px] h-[38px] rounded-[6px] bg-white border border-solid border-[#d6d6d6] cursor-pointer p-0"
                  >
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                      <path d="M7 1V13" stroke="#01152E" strokeWidth="1.5" strokeLinecap="round" />
                      <path d="M1 7H13" stroke="#01152E" strokeWidth="1.5" strokeLinecap="round" />
                    </svg>
                  </button>
                  <button
                    type="button"
                    aria-label="Zoom out"
                    onClick={() => {
                      const map = locationMapRef.current;
                      if (map) map.setZoom(Math.max((map.getZoom() || 13) - 1, LOCATION_MAP_MIN_ZOOM));
                    }}
                    className="flex items-center justify-center w-[38px] h-[38px] rounded-[6px] bg-white border border-solid border-[#d6d6d6] cursor-pointer p-0"
                  >
                    <svg width="14" height="2" viewBox="0 0 14 2" fill="none">
                      <path d="M1 1H13" stroke="#01152E" strokeWidth="1.5" strokeLinecap="round" />
                    </svg>
                  </button>
                </div>
                <GoogleMapReact
                  center={{ lat, lng }}
                  defaultZoom={13}
                  bootstrapURLKeys={{ key: "AIzaSyDE4YXJP-Oq9uXDySWbJBOBtwej5bdrw1A" }}
                  yesIWantToUseGoogleMapApiInternals
                  onGoogleApiLoaded={({ map }) => { locationMapRef.current = map; }}
                  options={{
                    styles: locationMapStyles,
                    gestureHandling: "cooperative",
                    scrollwheel: false,
                    fullscreenControl: false,
                    mapTypeId: "roadmap",
                    disableDefaultUI: true,
                    zoomControl: false,
                    clickableIcons: false,
                    minZoom: LOCATION_MAP_MIN_ZOOM,
                    maxZoom: LOCATION_MAP_MAX_ZOOM,
                  }}
                >
                  <div
                    // @ts-ignore — lat/lng required by GoogleMapReact children
                    lat={lat}
                    lng={lng}
                    style={{ transform: "translate(-50%, -100%)" }}
                  >
                    <img
                      src={mapMarkerIcon}
                      alt="Property location"
                      style={{ width: 22, height: 30 }}
                    />
                  </div>
                </GoogleMapReact>
              </div>
            );
          })()}

        </div>

        {/* RIGHT COLUMN — Sidebar card. Full width when stacked below the
            details on mobile/tablet; fixed 385px beside them on desktop.
            paymentSectionRef is the scroll target for the mobile/tablet sticky
            "Reserve" button, which brings the check-in/check-out box into view. */}
        <div ref={paymentSectionRef} className="w-full lg:w-[385px] flex-shrink-0 scroll-mt-24">
          {/* No overflow-hidden here: the date/guest dropdowns are absolutely
              positioned inside this card and would be clipped by it. All content
              is inset by the 20px padding, so the rounded corners stay clean. */}
          <div
            className="rounded-[12px] bg-white"
            style={{
              border: "1px solid #d6d6d6",
              boxShadow: "0px 0px 12px rgba(42,54,84,0.1)",
            }}
          >
            {/* Sidebar content */}
            <div style={{ padding: 20 }}>
              {/* Check In / Check Out */}
              <div ref={datePickerRef} style={{ position: "relative" }}>
                <div
                  onClick={() => {
                    setShowDatePicker(!showDatePicker);
                    if (!showDatePicker) {
                      setDateSelecting(startDate && !endDate ? "end" : "start");
                      if (startDate) {
                        setCalBaseMonth({ year: startDate.getFullYear(), month: startDate.getMonth() });
                      }
                    }
                  }}
                  style={{
                    display: "flex",
                    border: "1px solid #d6d6d6",
                    borderRadius: 8,
                    cursor: "pointer",
                    overflow: "hidden",
                  }}
                >
                  {/* Check In */}
                  <div style={{ flex: 1, padding: "12px 16px" }}>
                    <p
                      style={{
                        fontFamily: "Poppins, sans-serif",
                        fontWeight: 500,
                        fontSize: 9,
                        lineHeight: "14px",
                        letterSpacing: "1.8px",
                        color: "#01152E",
                        textTransform: "uppercase",
                        margin: 0,
                      }}
                    >
                      {t("listingStayDetail.checkIn")}
                    </p>
                    <p
                      style={{
                        fontFamily: "Poppins, sans-serif",
                        fontWeight: 600,
                        fontSize: 14,
                        lineHeight: "24px",
                        color: "#01152E",
                        margin: 0,
                        marginTop: 2,
                      }}
                    >
                      {startDate ? fmtDisplayDate(startDate) : t("listingStayDetail.addDate")}
                    </p>
                  </div>
                  {/* Divider */}
                  <div style={{ width: 1, backgroundColor: "#d6d6d6", alignSelf: "stretch" }} />
                  {/* Check Out */}
                  <div style={{ flex: 1, padding: "12px 16px" }}>
                    <p
                      style={{
                        fontFamily: "Poppins, sans-serif",
                        fontWeight: 500,
                        fontSize: 9,
                        lineHeight: "14px",
                        letterSpacing: "1.8px",
                        color: "#01152E",
                        textTransform: "uppercase",
                        margin: 0,
                      }}
                    >
                      {t("listingStayDetail.checkOut")}
                    </p>
                    <p
                      style={{
                        fontFamily: "Poppins, sans-serif",
                        fontWeight: 600,
                        fontSize: 14,
                        lineHeight: "24px",
                        color: "#01152E",
                        margin: 0,
                        marginTop: 2,
                      }}
                    >
                      {endDate ? fmtDisplayDate(endDate) : t("listingStayDetail.addDate")}
                    </p>
                  </div>
                </div>

                {/* Date picker dropdown */}
                {showDatePicker && (
                  // Two months side by side need more room than the 345px card
                  // interior, so the panel is right-anchored and overhangs the
                  // card to the left instead of squeezing the day cells.
                  <div
                    className="eu-datepicker-panel"
                    style={{
                      position: "absolute",
                      top: "calc(100% + 8px)",
                      right: 0,
                      left: "auto",
                      width: 420,
                      backgroundColor: "#ffffff",
                      borderRadius: 12,
                      border: "1px solid #d6d6d6",
                      boxShadow: "0px 4px 20px rgba(0,0,0,0.12)",
                      padding: 16,
                      zIndex: 50,
                    }}
                  >
                    {/* Month navigation */}
                    <div className="flex items-center justify-between" style={{ marginBottom: 8 }}>
                      <button
                        onClick={() => {
                          const prev = calPrevMonth(calBaseMonth.year, calBaseMonth.month);
                          setCalBaseMonth(prev);
                        }}
                        style={{
                          background: "none",
                          border: "none",
                          cursor: "pointer",
                          padding: 4,
                        }}
                      >
                        <svg width="8" height="14" viewBox="0 0 8 14" fill="none">
                          <path d="M7 1L1 7L7 13" stroke="#01152E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </button>
                      <button
                        onClick={() => {
                          const next = calNextMonth(calBaseMonth.year, calBaseMonth.month);
                          setCalBaseMonth(next);
                        }}
                        style={{
                          background: "none",
                          border: "none",
                          cursor: "pointer",
                          padding: 4,
                        }}
                      >
                        <svg width="8" height="14" viewBox="0 0 8 14" fill="none">
                          <path d="M1 1L7 7L1 13" stroke="#01152E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </button>
                    </div>
                    {/* Two month calendars */}
                    <div className="flex gap-[16px] eu-datepicker-months">
                      {renderCalMonth(calBaseMonth.year, calBaseMonth.month)}
                      {renderCalMonth(calSecond.year, calSecond.month)}
                    </div>
                  </div>
                )}
              </div>

              {/* Guests */}
              <div ref={guestPickerRef} style={{ position: "relative", marginTop: 12 }}>
                <div
                  onClick={() => setShowGuestPicker(!showGuestPicker)}
                  style={{
                    border: "1px solid #d6d6d6",
                    borderRadius: 8,
                    padding: "12px 16px",
                    cursor: "pointer",
                  }}
                >
                  <p
                    style={{
                      fontFamily: "Poppins, sans-serif",
                      fontWeight: 500,
                      fontSize: 9,
                      lineHeight: "14px",
                      letterSpacing: "1.8px",
                      color: "#01152E",
                      textTransform: "uppercase",
                      margin: 0,
                    }}
                  >
                    {t("common.guests")}
                  </p>
                  <p
                    style={{
                      fontFamily: "Poppins, sans-serif",
                      fontWeight: 600,
                      fontSize: 14,
                      lineHeight: "24px",
                      color: "#01152E",
                      margin: 0,
                      marginTop: 2,
                    }}
                  >
                    {fmtGuestsSummary()}
                  </p>
                </div>

                {/* Guest picker dropdown */}
                {showGuestPicker && (
                  <div
                    style={{
                      position: "absolute",
                      top: "calc(100% + 8px)",
                      left: 0,
                      right: 0,
                      backgroundColor: "#ffffff",
                      borderRadius: 12,
                      border: "1px solid #d6d6d6",
                      boxShadow: "0px 4px 20px rgba(0,0,0,0.12)",
                      padding: "20px 16px",
                      zIndex: 50,
                    }}
                  >
                    <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
                      {GUEST_ROWS.map((row) => {
                        const value = getGuestValue(row.key);
                        return (
                          <div key={row.key} style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                            <div>
                              <p
                                style={{
                                  fontFamily: "Poppins, sans-serif",
                                  fontWeight: 500,
                                  fontSize: 14,
                                  lineHeight: "18px",
                                  color: "#01152E",
                                  margin: 0,
                                }}
                              >
                                {row.label}
                              </p>
                              <p
                                style={{
                                  fontFamily: "Roboto, sans-serif",
                                  fontWeight: 400,
                                  fontSize: 10,
                                  lineHeight: "12px",
                                  color: "#445162",
                                  margin: 0,
                                  marginTop: 4,
                                }}
                              >
                                {row.desc}
                              </p>
                            </div>
                            <div style={{ display: "flex", alignItems: "center", gap: 17 }}>
                              <button
                                onClick={() => setGuestValue(row.key, value - 1)}
                                style={{ background: "transparent", border: "none", padding: 0, cursor: "pointer", display: "flex" }}
                              >
                                <img src={minusCircleIcon} alt="−" width={24} height={24} />
                              </button>
                              <span
                                style={{
                                  fontFamily: "Poppins, sans-serif",
                                  fontWeight: 600,
                                  fontSize: 16,
                                  lineHeight: "24px",
                                  color: "#01152E",
                                  width: 12,
                                  textAlign: "center",
                                }}
                              >
                                {value}
                              </span>
                              <button
                                onClick={() => setGuestValue(row.key, value + 1)}
                                style={{ background: "transparent", border: "none", padding: 0, cursor: "pointer", display: "flex" }}
                              >
                                <img src={plusCircleIcon} alt="+" width={24} height={24} />
                              </button>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>

              {/* Rate/booking errors — minimum stay, unavailable dates, failed
                  payment. This state was previously set in ten places and read in
                  none, which is why those failures were invisible. */}
              {errorMessage && (
                <div
                  role="alert"
                  style={{
                    marginTop: 12,
                    padding: "10px 12px",
                    borderRadius: 8,
                    backgroundColor: "#fdf2f2",
                    border: "1px solid #f0c8c8",
                  }}
                >
                  <p
                    style={{
                      fontFamily: "Poppins, sans-serif",
                      fontWeight: 500,
                      fontSize: 12,
                      lineHeight: "18px",
                      color: "#b42318",
                      margin: 0,
                    }}
                  >
                    {errorMessage}
                  </p>
                </div>
              )}

              {/* Cancellation Policy */}
              {(propertyDetails?.cancellation_policy || propertyDetails?.cancellation_policy_fr) && (
                <div style={{ marginTop: 30 }}>
                  <p
                    style={{
                      fontFamily: "Poppins, sans-serif",
                      fontWeight: 500,
                      fontSize: 12,
                      lineHeight: "14px",
                      letterSpacing: "1.2px",
                      color: "#01152E",
                      textTransform: "uppercase",
                      margin: 0,
                    }}
                  >
                    {t("listingStayDetail.cancellationPolicy")}
                  </p>
                  <div style={{ marginTop: 19 }}>
                    {(locale === "fr" && propertyDetails.cancellation_policy_fr
                      ? propertyDetails.cancellation_policy_fr
                      : propertyDetails.cancellation_policy || ""
                    ).split("\n").filter(Boolean).map((line: string, i: number) => (
                      <p
                        key={i}
                        style={{
                          fontFamily: "Roboto, sans-serif",
                          fontWeight: 400,
                          fontSize: 12,
                          lineHeight: "18px",
                          color: "#445162",
                          margin: 0,
                        }}
                      >
                        {line.replace(/^-\s*/, "")}
                      </p>
                    ))}
                  </div>
                </div>
              )}

              {/* Separator */}
              <div style={{ width: "100%", height: 1, backgroundColor: "#d6d6d6", marginTop: 26 }} />

              {/* You can also find this property listed on */}
              {propertyDetails?.url_links?.some((l: any) => l?.url) && (
                <>
                  <p
                    style={{
                      fontFamily: "Poppins, sans-serif",
                      fontWeight: 500,
                      fontSize: 12,
                      lineHeight: "14px",
                      letterSpacing: "1.2px",
                      color: "#01152E",
                      textTransform: "uppercase",
                      margin: 0,
                      marginTop: 20,
                    }}
                  >
                    {t("listingStayDetail.alsoListedOn")}
                  </p>

                  {/* Platform logos */}
                  <div style={{ display: "flex", flexWrap: "wrap", columnGap: 20, rowGap: 12, marginTop: 16 }}>
                    {propertyDetails.url_links
                      .filter((platform: any) => platform?.url)
                      .map((platform: any, i: number) => {
                        const meta = PLATFORM_META[platform.siteType];
                        const logo = meta?.logo || getFallbackFavicon(platform.url);
                        const label = meta?.label || platform.siteType || "Listing";
                        return (
                          <a
                            key={i}
                            href={platform.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ display: "flex", alignItems: "center", gap: 6, textDecoration: "none" }}
                          >
                            {logo && (
                              <img
                                src={logo}
                                alt={label}
                                style={{ width: 20, height: 20, borderRadius: "50%", objectFit: "cover" }}
                                onError={(e) => { (e.target as HTMLImageElement).style.display = "none"; }}
                              />
                            )}
                            <span
                              style={{
                                fontFamily: "Manrope, sans-serif",
                                fontWeight: 500,
                                fontSize: 12,
                                lineHeight: "24px",
                                color: "#01152E",
                              }}
                            >
                              {label}
                            </span>
                          </a>
                        );
                      })}
                  </div>

                  {/* Separator */}
                  <div style={{ width: "100%", height: 1, backgroundColor: "#d6d6d6", marginTop: 26 }} />
                </>
              )}

              {/* Total price */}
              {startDate && endDate && (() => {
                const clientNights = Math.round(
                  (endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24)
                );

                // Price off rateData, never base_price. /calculate_rate applies
                // per-date pricing and long-stay discounts; base_price is only
                // the advertised headline rate, so multiplying it by the night
                // count showed a figure that disagreed with the Total below
                // (which is the server's) and with what Stripe actually charges.
                // base_price is kept purely as a placeholder for the moment
                // before the rate call resolves.
                const nights = Number(rateData?.nights) || clientNights;

                // calRateWithoutfees is the sum of the per-date rates BEFORE
                // any long-stay discount; rentWithDescount is the same figure
                // after it. The breakdown shows the former with the discount
                // as its own deduction, the headline shows the latter, which
                // is what the guest actually pays in rent.
                const total =
                  Number(rateData?.calRateWithoutfees) ||
                  (Number(propertyDetails?.base_price) || 0) * clientNights;
                const discounts =
                  (Number(rateData?.weeklyDisc) || 0) +
                  (Number(rateData?.monthlyDisc) || 0);
                const rentPayable =
                  Number(rateData?.rentWithDescount) || total - discounts;
                const perNight = nights > 0 ? total / nights : 0;

                return nights > 0 ? (
                  <>
                    <div style={{ display: "flex", alignItems: "center", gap: 6, marginTop: 20 }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 2 }}>
                        <span
                          style={{
                            fontFamily: "Poppins, sans-serif",
                            fontWeight: 600,
                            fontSize: 24,
                            lineHeight: "24px",
                            color: "#01152E",
                          }}
                        >
                          €{formatAmount(Number(rateData?.totalRate) || rentPayable, locale)}
                        </span>
                      </div>
                      <span
                        style={{
                          fontFamily: "Poppins, sans-serif",
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: "24px",
                          color: "#445162",
                        }}
                      >
                        {t("listingStayDetail.forNights")} {nights} {nights !== 1 ? t("listingStayDetail.nights") : t("listingStayDetail.night")}
                      </span>
                    </div>
                    <button
                      onClick={() => setShowPriceDetails(!showPriceDetails)}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 4,
                        marginTop: 15,
                        background: "none",
                        border: "none",
                        padding: 0,
                        cursor: "pointer",
                      }}
                    >
                      <span
                        style={{
                          fontFamily: "Poppins, sans-serif",
                          fontWeight: 600,
                          fontSize: 12,
                          lineHeight: "24px",
                          letterSpacing: "1.2px",
                          color: "#01152E",
                          textTransform: "uppercase",
                          textDecoration: "underline",
                          textUnderlineOffset: "2px",
                        }}
                      >
                        {showPriceDetails ? t("listingStayDetail.hide") : t("listingStayDetail.show")} {t("listingStayDetail.priceDetails")}
                      </span>
                      <svg
                        width="10"
                        height="6"
                        viewBox="0 0 10 6"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{
                          transform: showPriceDetails ? "rotate(0deg)" : "rotate(180deg)",
                          transition: "transform 0.2s",
                        }}
                      >
                        <path d="M9 5L5 1L1 5" stroke="#01152E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </button>
                    {showPriceDetails && (
                      <div style={{ marginTop: 40 }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                          <span
                            style={{
                              fontFamily: "Poppins, sans-serif",
                              fontWeight: 500,
                              fontSize: 14,
                              lineHeight: "24px",
                              color: "#01152E",
                            }}
                          >
                            € {formatAmount(perNight, locale)} × {nights} {nights !== 1 ? t("listingStayDetail.nights") : t("listingStayDetail.night")}
                          </span>
                          <span
                            style={{
                              fontFamily: "Poppins, sans-serif",
                              fontWeight: 500,
                              fontSize: 14,
                              lineHeight: "24px",
                              color: "#445162",
                            }}
                          >
                            € {formatAmount(total, locale)}
                          </span>
                        </div>
                        {/* Long stay discounts. The rent line above is
                            calRateWithoutfees, which is PRE-discount, so
                            without these the column reads high and stops
                            summing to the Total at the bottom. Guarded with
                            > 0 rather than the old page's truthiness check,
                            which rendered a bare "0" when the value was 0. */}
                        {[
                          Number(rateData?.weeklyDisc) || 0,
                          Number(rateData?.monthlyDisc) || 0,
                        ].map((discount, idx) =>
                          discount > 0 ? (
                            <div
                              key={idx}
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginTop: 16,
                              }}
                            >
                              <span
                                style={{
                                  fontFamily: "Poppins, sans-serif",
                                  fontWeight: 500,
                                  fontSize: 14,
                                  lineHeight: "24px",
                                  color: "#01152E",
                                }}
                              >
                                {t("listingStayDetail.longStayDiscount")}
                              </span>
                              <span
                                style={{
                                  fontFamily: "Poppins, sans-serif",
                                  fontWeight: 500,
                                  fontSize: 14,
                                  lineHeight: "24px",
                                  color: "#01152E",
                                }}
                              >
                                − € {formatAmount(discount, locale)}
                              </span>
                            </div>
                          ) : null
                        )}
                        {/* Separator */}
                        <div style={{ width: "100%", height: 1, backgroundColor: "#d6d6d6", marginTop: 16 }} />
                        {/* Fees row — the label opens a breakdown popover */}
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 16 }}>
                          <div ref={feesPopupRef} style={{ position: "relative" }}>
                            <button
                              type="button"
                              onClick={() => setShowFeesPopup((v) => !v)}
                              aria-expanded={showFeesPopup}
                              style={{
                                fontFamily: "Poppins, sans-serif",
                                fontWeight: 600,
                                fontSize: 14,
                                lineHeight: "24px",
                                letterSpacing: "1.4px",
                                color: "#01152E",
                                textTransform: "uppercase",
                                textDecoration: "underline",
                                textUnderlineOffset: "2px",
                                background: "none",
                                border: "none",
                                padding: 0,
                                cursor: "pointer",
                              }}
                            >
                              {t("listingStayDetail.fees")}
                            </button>
                            {showFeesPopup && (
                              <div
                                className="eu-fees-popup"
                                style={{
                                  position: "absolute",
                                  left: -230,
                                  top: "calc(100% + 12px)",
                                  zIndex: 50,
                                  width: 280,
                                  backgroundColor: "#fff",
                                  borderRadius: 12,
                                  boxShadow: "0px 0px 10px rgba(0,0,0,0.25)",
                                  padding: 20,
                                }}
                              >
                                <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                                  {[
                                    { label: t("listingStayDetail.cleaningFee"), value: Number(rateData?.cleaningFees) || 0 },
                                    { label: t("listingStayDetail.communityFee"), value: Number(rateData?.communityFees) || 0 },
                                    { label: t("listingStayDetail.managementFee"), value: Number(rateData?.managementFees) || 0 },
                                  ].map((row) => (
                                    <div key={row.label} style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                      <span style={{ fontFamily: "Poppins, sans-serif", fontWeight: 400, fontSize: 14, lineHeight: "24px", color: "#445162" }}>
                                        {row.label}
                                      </span>
                                      <span style={{ fontFamily: "Poppins, sans-serif", fontWeight: 500, fontSize: 14, lineHeight: "24px", color: "#01152E" }}>
                                        € {formatAmount(row.value, locale)}
                                      </span>
                                    </div>
                                  ))}
                                  <div style={{ width: "100%", height: 1, backgroundColor: "#d6d6d6", marginTop: 4 }} />
                                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    <span style={{ fontFamily: "Poppins, sans-serif", fontWeight: 600, fontSize: 14, lineHeight: "24px", color: "#01152E" }}>
                                      {t("payDone.total")}
                                    </span>
                                    <span style={{ fontFamily: "Poppins, sans-serif", fontWeight: 600, fontSize: 14, lineHeight: "24px", color: "#01152E" }}>
                                      € {formatAmount(
                                        (Number(rateData?.cleaningFees) || 0) +
                                        (Number(rateData?.communityFees) || 0) +
                                        (Number(rateData?.managementFees) || 0),
                                        locale
                                      )}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                          <span
                            style={{
                              fontFamily: "Poppins, sans-serif",
                              fontWeight: 500,
                              fontSize: 14,
                              lineHeight: "24px",
                              color: "#445162",
                            }}
                          >
                            + € {formatAmount(
                              (Number(rateData?.cleaningFees) || 0) +
                              (Number(rateData?.communityFees) || 0) +
                              (Number(rateData?.managementFees) || 0),
                              locale,
                              0
                            )}
                          </span>
                        </div>
                        {/* Separator */}
                        <div style={{ width: "100%", height: 1, backgroundColor: "#d6d6d6", marginTop: 16 }} />
                        {/* Taxes row */}
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 16 }}>
                          <span
                            style={{
                              fontFamily: "Poppins, sans-serif",
                              fontWeight: 500,
                              fontSize: 14,
                              lineHeight: "24px",
                              color: "#01152E",
                            }}
                          >
                            {t("listingStayDetail.taxes")}
                          </span>
                          <span
                            style={{
                              fontFamily: "Poppins, sans-serif",
                              fontWeight: 500,
                              fontSize: 14,
                              lineHeight: "24px",
                              color: "#445162",
                            }}
                          >
                            + € {formatAmount(Number(rateData?.cityTax) || 0, locale)}
                          </span>
                        </div>
                        {/* Separator */}
                        <div style={{ width: "100%", height: 1, backgroundColor: "#d6d6d6", marginTop: 16 }} />
                        {/* Personal Details row — label stays greyed out until the
                            guest has actually filled the form; the pencil opens it
                            either way, to fill in or to edit. */}
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 16 }}>
                          <button
                            type="button"
                            onClick={() => setOpenContactModal(true)}
                            style={{
                              fontFamily: "Poppins, sans-serif",
                              fontWeight: 600,
                              fontSize: 14,
                              lineHeight: "24px",
                              letterSpacing: "1.4px",
                              color: isPersonalDetailsFilled ? "#01152E" : "#d6d6d6",
                              textTransform: "uppercase",
                              textDecoration: "underline",
                              textUnderlineOffset: "2px",
                              background: "none",
                              border: "none",
                              padding: 0,
                              textAlign: "left",
                              cursor: "pointer",
                            }}
                          >
                            {t("listingStayDetail.personalDetails")}
                          </button>
                          <button
                            type="button"
                            onClick={() => setOpenContactModal(true)}
                            aria-label={isPersonalDetailsFilled ? t("listingStayDetail.editPersonalDetails") : t("listingStayDetail.addPersonalDetails")}
                            style={{
                              background: "none",
                              border: "none",
                              padding: 0,
                              cursor: "pointer",
                              display: "flex",
                              flexShrink: 0,
                            }}
                          >
                            <img src={penToSquareIcon} alt="" style={{ width: 16, height: 16 }} />
                          </button>
                        </div>
                        {/* Separator */}
                        <div style={{ width: "100%", height: 1, backgroundColor: "#d6d6d6", marginTop: 16 }} />
                        {/* Total row */}
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 16 }}>
                          <span
                            style={{
                              fontFamily: "Poppins, sans-serif",
                              fontWeight: 600,
                              fontSize: 20,
                              lineHeight: "24px",
                              color: "#01152E",
                            }}
                          >
                            {t("payDone.total")}
                          </span>
                          <span
                            style={{
                              fontFamily: "Poppins, sans-serif",
                              fontWeight: 600,
                              fontSize: 20,
                              lineHeight: "24px",
                              color: "#01152E",
                            }}
                          >
                            € {formatAmount(Number(rateData?.totalRate) || rentPayable, locale)}
                          </span>
                        </div>
                      </div>
                    )}
                    {/* Book Now button */}
                    <button
                      onClick={() => setOpenContactModal(true)}
                      style={{
                        width: "100%",
                        marginTop: 24,
                        padding: "10px 24px",
                        backgroundColor: "#01152E",
                        border: "1px solid #01152E",
                        borderRadius: 30,
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <span
                        style={{
                          fontFamily: "Poppins, sans-serif",
                          fontWeight: 500,
                          fontSize: 14,
                          lineHeight: "24px",
                          color: "#ffffff",
                        }}
                      >
                        {t("common.bookNow")}
                      </span>
                    </button>
                  </>
                ) : null;
              })()}
            </div>
          </div>
        </div>
      </main>

      {/* Full-width sections below two-column layout */}
      <div className="px-4 sm:px-8 xl:px-[120px]">
        {/* Separator below map */}
        <div style={{ width: "100%", height: 1, backgroundColor: "#d6d6d6", marginTop: 40 }} />

        {/* Reviews section — rendered only when there is something published */}
        {reviews.length > 0 && (
        // scrollMarginTop keeps the heading clear of the sticky header when the
        // rating row at the top jumps here.
        <div id="reviews" style={{ marginTop: 40, scrollMarginTop: 120 }}>
          <h3 style={{
            fontFamily: "Poppins, sans-serif",
            fontWeight: 600,
            fontSize: 18,
            lineHeight: "24px",
            color: "#01152E",
            margin: 0,
          }}>
            {reviewsSummary.count} {t("listingStayDetail.reviews")}
          </h3>
          <div style={{ display: "flex", alignItems: "center", gap: 12, marginTop: 12 }}>
            {renderStars(reviewsSummary.average || 0, "section", 24, 22, "#B88333", 6)}
            <span style={{
              fontFamily: "Poppins, sans-serif",
              fontWeight: 600,
              fontSize: 20,
              lineHeight: "24px",
              letterSpacing: "-0.4px",
              color: "#445162",
            }}>
              {reviewsSummary.average != null ? reviewsSummary.average.toFixed(1) : "—"}
            </span>
          </div>

          {/* Review cards — 2 x 2 grid */}
          <div className="eu-reviews-grid" style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 28, marginTop: 52 }}>
            {reviews.map((review, idx) => {
              const platformLogo = reviewPlatformLogo(review.source);
              const text = reviewDisplayText(review);
              const cardKey = review._id || String(idx);
              // A little slack over the limit: a review only a few characters
              // past it reads better whole than with a toggle after it.
              const isLong = text.length > REVIEW_CLAMP + 20;
              // Airbnb cut this comment in its email, so the page never holds
              // the whole of it: "Show more" goes to Airbnb instead of
              // expanding here, and with no link the text just ends in "…".
              const isCut = !!review.text_truncated;
              const isExpanded = !isCut && !!expandedReviews[cardKey];
              const shownText = isLong && !isExpanded ? truncateReview(text) : text;
              const showMoreStyle: React.CSSProperties = {
                fontFamily: "Poppins, sans-serif",
                fontWeight: 600,
                fontSize: 12,
                letterSpacing: "1.2px",
                color: "#01152E",
                textTransform: "uppercase",
                textDecoration: "underline",
                textUnderlineOffset: "2px",
                cursor: "pointer",
                whiteSpace: "nowrap",
                marginLeft: isExpanded ? 6 : 0,
              };
              return (
              <div key={review._id || idx} style={{ display: "flex", flexDirection: "column", gap: 20 }}>
                {/* Header row: avatar + info */}
                <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                  {/* Avatar — the channels give us no photo, so the guest's
                      initial is used instead of a stock face. */}
                  <div
                    aria-hidden="true"
                    style={{
                      width: 60,
                      height: 60,
                      borderRadius: "50%",
                      flexShrink: 0,
                      backgroundColor: "#f5eee4",
                      color: "#B88333",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontFamily: "Poppins, sans-serif",
                      fontWeight: 600,
                      fontSize: 24,
                    }}
                  >
                    {/* No name → initial of the "Guest" label shown beside it. */}
                    {reviewInitial(review.guest_name || t("listingStayDetail.guest"))}
                  </div>
                  {/* Name, date, stars, platform */}
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <span style={{
                      fontFamily: "Poppins, sans-serif",
                      fontWeight: 500,
                      fontSize: 18,
                      lineHeight: "18px",
                      letterSpacing: "-0.36px",
                      color: "#01152E",
                      display: "block",
                    }}>
                      {review.guest_name || t("listingStayDetail.guest")}
                    </span>
                    <span style={{
                      fontFamily: "Roboto, sans-serif",
                      fontWeight: 400,
                      fontSize: 12,
                      lineHeight: "12px",
                      color: "#445162",
                      display: "block",
                      marginTop: 4,
                    }}>
                      {review.review_date ? moment(review.review_date).format("MMMM YYYY") : ""}
                    </span>
                    <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 4 }}>
                      {renderStars(review.rating_five || 0, `review-${idx}`, 14, 11)}
                      {/* Vertical divider */}
                      <div style={{ width: 1, height: 8, backgroundColor: "#d6d6d6" }} />
                      <span style={{
                        fontFamily: "Poppins, sans-serif",
                        fontWeight: 600,
                        fontSize: 12,
                        lineHeight: "24px",
                        letterSpacing: "-0.24px",
                        color: "#01152E",
                      }}>
                        {review.rating_five != null ? review.rating_five.toFixed(1) : "—"}
                      </span>
                      {platformLogo && (
                        <>
                          {/* Vertical divider */}
                          <div style={{ width: 1, height: 20, backgroundColor: "#d6d6d6" }} />
                          <img
                            src={platformLogo}
                            alt={review.source || "platform"}
                            style={{ height: 20, width: "auto", objectFit: "contain" }}
                          />
                        </>
                      )}
                    </div>
                  </div>
                </div>
                {/* Review text */}
                <p style={{
                  fontFamily: "Roboto, sans-serif",
                  fontWeight: 400,
                  fontSize: 16,
                  lineHeight: "24px",
                  color: "#445162",
                  margin: 0,
                }}>
                  {shownText}
                  {(isCut || (isLong && !isExpanded)) && "… "}
                  {isCut && review.read_more_url && (
                    <a
                      href={review.read_more_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={showMoreStyle}
                    >
                      {t("listingStayDetail.showMoreLower")}
                    </a>
                  )}
                  {!isCut && isLong && (
                    <span
                      role="button"
                      tabIndex={0}
                      onClick={() =>
                        setExpandedReviews((prev) => ({ ...prev, [cardKey]: !prev[cardKey] }))
                      }
                      onKeyDown={(event) => {
                        if (event.key === "Enter" || event.key === " ") {
                          event.preventDefault();
                          setExpandedReviews((prev) => ({ ...prev, [cardKey]: !prev[cardKey] }));
                        }
                      }}
                      style={showMoreStyle}
                    >
                      {isExpanded ? t("listingStayDetail.showLess") : t("listingStayDetail.showMoreLower")}
                    </span>
                  )}
                </p>
              </div>
              );
            })}
          </div>
          {/* Only offered while there are more reviews than the four shown. */}
          {!showAllReviews && reviewsSummary.count > reviews.length && (
            <span
              onClick={() => { setShowAllReviews(true); fetchPropertyReviews(true); }}
              style={{
                fontFamily: "Poppins, sans-serif",
                fontWeight: 600,
                fontSize: 12,
                lineHeight: "24px",
                letterSpacing: "1.2px",
                color: "#01152E",
                textTransform: "uppercase",
                textDecoration: "underline",
                textUnderlineOffset: "2px",
                cursor: "pointer",
                marginTop: 52,
                display: "inline-block",
              }}
            >
              {t("listingStayDetail.showAllReviews")}
            </span>
          )}
        </div>
        )}

      </div>

      {/* Trust banner — full bleed, flush with footer */}
      <div className="eu-trust-banner" style={{
        backgroundColor: "#f5eee4",
        padding: "70px 120px 90px",
        marginTop: 40,
        marginBottom: 0,
        display: "flex",
        gap: 60,
        alignItems: "flex-start",
        width: "100vw",
        marginLeft: "calc(-50vw + 50%)",
      }}>
        {[
          { icon: trustManagedIcon, iconW: 80, iconH: 80, title: t("listingStayDetail.trust.managedTitle"), desc: t("listingStayDetail.trust.managedDesc") },
          { icon: trustGuestsIcon, iconW: 90, iconH: 80, title: t("listingStayDetail.trust.guestsTitle"), desc: t("listingStayDetail.trust.guestsDesc") },
          { icon: trustSecureIcon, iconW: 86, iconH: 72, title: t("listingStayDetail.trust.secureTitle"), desc: t("listingStayDetail.trust.secureDesc") },
        ].map((item, idx) => (
          <div key={idx} style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", gap: 30, textAlign: "center" }}>
            <img src={item.icon} alt={item.title} style={{ width: item.iconW, height: item.iconH }} />
            <div style={{ display: "flex", flexDirection: "column", gap: 15 }}>
              <span style={{
                fontFamily: "Poppins, sans-serif",
                fontWeight: 600,
                fontSize: 16,
                lineHeight: "24px",
                letterSpacing: "0.32px",
                color: "#01152E",
              }}>
                {item.title}
              </span>
              <span style={{
                fontFamily: "Roboto, sans-serif",
                fontWeight: 400,
                fontSize: 14,
                lineHeight: "20px",
                color: "#445162",
              }}>
                {item.desc}
              </span>
            </div>
          </div>
        ))}
      </div>

      <PhotoGalleryModal
        isOpen={galleryOpen}
        onClose={() => setGalleryOpen(false)}
        initialIndex={galleryInitialIndex}
        propertyTitle={propertyDetails?.title || ""}
        propertyLocation={propertyDetails?.location || ""}
        propertyId={id || ""}
        carouselImages={images}
        amenities={propertyDetails?.amenities || []}
      />
      <ContactFormModal
        formValues={formValues}
        bookProperty={bookProperty}
        setFormValues={setFormValues}
        isOpen={openContactModal}
        onClose={() => {
          setOpenContactModal(false);
          setFormValues({ name: "", email: "", phone: "", isChecked: false });
        }}
      />
    </div>
  );
};

export default function ListingStayDetailPage() {
  return (
    <DetailPagetLayout>
      <StayDetailPageContainer />
    </DetailPagetLayout>
  );
}
